export const RULESETS = {
    '50K': '50K',
    '48K': '48K',
    '48V': '48V',
    '50V': '50V',
    SELECTION: 'SEL_RTU',
};
export const TAGS = {
    ACC_CAT_CONTROLS: 'ACC_CAT_CONTROLS',
    ACCESSORY: 'ACCESSORY',
    UI: 'UI',
    UI_CONFIG_UNIT: 'UI_CONFIG_UNIT',
    UI_CONFIG_UNIT_ACC: 'UI_CONFIG_UNIT_ACC',
    ACC_CAT_FILTERS: 'ACC_CAT_FILTERS',
    ACC_CAT_THERMOSTAT: 'ACC_CAT_THERMOSTAT',
    ACC_CAT_OUTSIDEAIR: 'ACC_CAT_OUTSIDEAIR',
    ACC_CAT_COMPSOUNDBLNK: 'ACC_CAT_COMPSOUNDBLNK',
    ACC_CAT_HAILGUARD: 'ACC_CAT_HAILGUARD',
    ACC_CAT_POWEREXH: 'ACC_CAT_POWEREXH',
    ACC_CAT_ROOFCURB: 'ACC_CAT_ROOFCURB',
    ACC_CAT_UVCBULBKIT: 'ACC_CAT_UVCBULBKIT',
    UI_CONFIG_UNIT_ACO: 'UI_CONFIG_UNIT_ACO',
    UI_CONFIG_UNIT_OPT: 'UI_CONFIG_UNIT_OPT',
    UI_SEL: 'UI_SEL',
    UI_SEL_REQ: 'UI_SEL_REQ',
    UI_SEL_REQ_REQ: 'UI_Sel_REQ_REQ',
    UI_SEL_REQ_MODEL: 'UI_Sel_REQ_MODEL',
    OPT_CAT_HUMIDIMIZER: 'OPT_CAT_HUMIDIMIZER',
    UI_SEL_DC: 'UI_SEL_DC',
    UI_SEL_DC_CAPREQ: 'UI_SEL_DC_CAPREQ',
    DC: 'DC',
    REPORT: 'REPORT',
    UI_DESCRIT: 'UI_DESCRIT',
    UI_DESCRIT_UNIT: 'UI_DESCRIT_UNIT',
    UI_SEL_DC_UNIT: 'UI_SEL_DC_UNIT',
    UI_SEL_DC_COND: 'UI_SEL_DC_COND',
    UI_ALWAYS: 'UI_ALWAYS',
    OPT: 'OPT',
    SC: 'SC',
    OPT_CAT_INDOOR: 'OPT_CAT_INDOOR',
    OPT_CAT_MISC: 'OPT_CAT_MISC',
    OPT_CAT_CONS: 'OPT_CAT_CONS',
    OPT_CAT_SS: 'OPT_CAT_SS',
    OPT_CAT_RC: 'OPT_CAT_RC',
    OPT_CAT_COILDRAIN: 'OPT_CAT_COILDRAIN',
    OPT_CAT_CONT: 'OPT_CAT_CONT',
    OPT_CAT_IAQ: 'OPT_CAT_IAQ',
    OPT_CAT_ELEC: 'OPT_CAT_ELEC',
    OPT_CAT_HEAT: 'OPT_CAT_HEAT',
    OPT_CAT_OUTDOORAIR_IR: 'OPT_CAT_OUTDOORAIR_IR',
    UI_CONFIG: 'UI_CONFIG',
    UI_CONFIG_UNIT_POSTAL_CODE: 'UI_CONFIG_UNIT_POSTAL_CODE',
    PN: 'PN',
    STARTUP_CAT_ALL: 'STARTUP_CAT_ALL',
    UI_CONFIG_UNIT_STARTUP: 'UI_CONFIG_UNIT_STARTUP',
    WARRANTY: 'WARRANTY',
    UI_CONFIG_UNIT_WAR: 'UI_CONFIG_UNIT_WAR',
    WAR_CAT_FIRSTYEARLABOR: 'WAR_CAT_FIRSTYEARLABOR',
    WAR_CAT_COMPLETEUNITPARTSANDLABOR: 'WAR_CAT_COMPLETEUNITPARTSANDLABOR',
    WAR_CAT_COMPLETEUNITPARTSONLY: 'WAR_CAT_COMPLETEUNITPARTSONLY',
    WAR_CAT_CMPUNITPARTSANDLABOR: 'WAR_CAT_CMPUNITPARTSANDLABOR',
    WAR_CAT_CMPUNITPARTSONLY: 'WAR_CAT_CMPUNITPARTSONLY',
    ACC_CAT_CONVKIT: 'ACC_CAT_CONVKIT',
    WAR_CAT_GASHEATPARTSONLY: 'WAR_CAT_GASHEATPARTSONLY',
    UI_SEL_DC_HW: 'UI_SEL_DC_HW',
    OPT_CAT_CHASSIS: 'OPT_CAT_CHASSIS',
};
export const RULES = {
    [TAGS.ACC_CAT_CONTROLS]: {
        ACC_B20AMPNONPOWERED: 'Acc_b20AmpNonPowered',
        ACC_B20AMPNONPOWERED_CONTROLTYPE_VISIBLE: 'Acc_b20AmpNonPowered.CONTROLTYPE.VISIBLE',
        ACC_BASPIRATORBOX: 'Acc_bAspiratorBox',
        ACC_BASPIRATORBOX_CONTROLTYPE_VISIBLE: 'Acc_bAspiratorBox.CONTROLTYPE.VISIBLE',
        ACC_BC02SPACETEMPNOLCD: 'Acc_bC02SpaceTempNoLCD',
        ACC_BC02SPACETEMPNOLCD_CONTROLTYPE_VISIBLE: 'Acc_bC02SpaceTempNoLCD.CONTROLTYPE.VISIBLE',
        ACC_BCARRIERTRANSLATORLOMWORKS: 'Acc_bCarrierTranslatorLomWorks',
        ACC_BCARRIERTRANSLATORLOMWORKS_CONTROLTYPE_VISIBLE: 'Acc_bCarrierTranslatorLomWorks.CONTROLTYPE.VISIBLE',
        ACC_BCARRIERTRANSLATORMODBUS: 'Acc_bCarrierTranslatorModbus',
        ACC_BCARRIERTRANSLATORMODBUS_CONTROLTYPE_VISIBLE: 'Acc_bCarrierTranslatorModbus.CONTROLTYPE.VISIBLE',
        ACC_BDUCTSUPPLYTEMPERATURE: 'Acc_bDuctSupplyTemperature',
        ACC_BDUCTSUPPLYTEMPERATURE_CONTROLTYPE_VISIBLE: 'Acc_bDuctSupplyTemperature.CONTROLTYPE.VISIBLE',
        ACC_BHORNORSTROBEANNUNCIATOR: 'Acc_bHornOrStrobeAnnunciator',
        ACC_BHORNORSTROBEANNUNCIATOR_CONTROLTYPE_VISIBLE: 'Acc_bHornOrStrobeAnnunciator.CONTROLTYPE.VISIBLE',
        ACC_BPLUGGEDFILTER: 'Acc_bPluggedFilter',
        ACC_BRETURNAIRSMOKEDETECTOR: 'Acc_bReturnAirSmokeDetector',
        ACC_BRHSPACESENSOR: 'Acc_bRHSpaceSensor',
        ACC_BRHSPACESENSOR_CONTROLTYPE_VISIBLE: 'Acc_bRHSpaceSensor.CONTROLTYPE.VISIBLE',
        ACC_BSMOKEDETECTOR: 'Acc_bSmokeDetector',
        ACC_BSMOKEDETECTOR_CONTROLTYPE_VISIBLE: 'Acc_bSmokeDetector.CONTROLTYPE.VISIBLE',
        ACC_BSMOKEDETECTORREMOTE: 'Acc_bSmokeDetectorRemote',
        ACC_BSMOKEDETECTORREMOTE_CONTROLTYPE_VISIBLE: 'Acc_bSmokeDetectorRemote.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPC02ROOMSENSOR: 'Acc_bSpaceTempC02RoomSensor',
        ACC_BSPACETEMPC02ROOMSENSOR_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempC02RoomSensor.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPC02ROOMSENSORSETPOINT: 'Acc_bSpaceTempC02RoomSensorSetPoint',
        ACC_BSPACETEMPLCDDISPLAY: 'Acc_bSpaceTempLCDDisplay',
        ACC_BSPACETEMPLCDDISPLAY_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempLCDDisplay.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPOVERRIDEBUTTON: 'Acc_bSpaceTempOverrideButton',
        ACC_BSPACETEMPOVERRIDEBUTTON_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempOverrideButton.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPSLIDEBAR: 'Acc_bSpaceTempSlideBar',
        ACC_BSPACETEMPSLIDEBAR_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempSlideBar.CONTROLTYPE.VISIBLE',
        ACC_BSUPPLYSMOKEDETECTOR: 'Acc_bSupplySmokeDetector',
        ACC_BSUPPLYSMOKEDETECTOR_CONTROLTYPE_VISIBLE: 'Acc_bSupplySmokeDetector.CONTROLTYPE.VISIBLE',
        ACC_BVFDDISPLAYKIT: 'Acc_bVFDDisplayKit',
        ACC_BVFDDISPLAYKIT_CONTROLTYPE_VISIBLE: 'Acc_bVFDDisplayKit.CONTROLTYPE.VISIBLE',
        ACC_BFILTERHOOK: 'Acc_bFilterHook',
        ACC_BFILTERHOOK_CONTROLTYPE_VISIBLE: 'Acc_bFilterHook.CONTROLTYPE.VISIBLE',
    },
    [TAGS.ACCESSORY]: {
        ACC_B20AMPNONPOWERED: 'Acc_b20AmpNonPowered',
        ACC_B20AMPNONPOWERED_CONTROLTYPE_VISIBLE: 'Acc_b20AmpNonPowered.CONTROLTYPE.VISIBLE',
        ACC_B2INCHMERV8FILTERKIT: 'Acc_b2InchMERV8FilterKit',
        ACC_B4INCHCOMMERCIALTHERMOSTAT: 'Acc_b4InchCommercialThermostat',
        ACC_B4INCHCOMMERCIALTHERMOSTAT_CONTROLTYPE_VISIBLE: 'Acc_b4InchCommercialThermostat.CONTROLTYPE.VISIBLE',
        ACC_B4INCHMERV13FILTERKIT: 'Acc_b4InchMERV13FilterKit',
        ACC_B4INCHMERV8CARBONFILTERKIT: 'Acc_b4InchMERV8CarbonFilterKit',
        ACC_B4INCHMERV8FILTERKIT: 'Acc_b4InchMERV8FilterKit',
        ACC_BASPIRATORBOX: 'Acc_bAspiratorBox',
        ACC_BASPIRATORBOX_CONTROLTYPE_VISIBLE: 'Acc_bAspiratorBox.CONTROLTYPE.VISIBLE',
        ACC_BBAROMETRICRELIEF: 'Acc_bBarometricRelief',
        ACC_BC02SPACETEMPNOLCD: 'Acc_bC02SpaceTempNoLCD',
        ACC_BC02SPACETEMPNOLCD_CONTROLTYPE_VISIBLE: 'Acc_bC02SpaceTempNoLCD.CONTROLTYPE.VISIBLE',
        ACC_BCARRIERTRANSLATORLOMWORKS: 'Acc_bCarrierTranslatorLomWorks',
        ACC_BCARRIERTRANSLATORLOMWORKS_CONTROLTYPE_VISIBLE: 'Acc_bCarrierTranslatorLomWorks.CONTROLTYPE.VISIBLE',
        ACC_BCARRIERTRANSLATORMODBUS: 'Acc_bCarrierTranslatorModbus',
        ACC_BCARRIERTRANSLATORMODBUS_CONTROLTYPE_VISIBLE: 'Acc_bCarrierTranslatorModbus.CONTROLTYPE.VISIBLE',
        ACC_BCOMFORT2STAGE: 'Acc_bComfort2Stage',
        ACC_BCOMFORT2STAGE_CONTROLTYPE_VISIBLE: 'Acc_bComfort2Stage.CONTROLTYPE.VISIBLE',
        ACC_BCOMMERCIALTHERMOSTAT: 'Acc_bCommercialThermostat',
        ACC_BCOMMERCIALTHERMOSTAT_CONTROLTYPE_VISIBLE: 'Acc_bCommercialThermostat.CONTROLTYPE.VISIBLE',
        ACC_BCOMPRESSORSOUNDBLANKET: 'Acc_bCompressorSoundBlanket',
        ACC_BDUCTSUPPLYTEMPERATURE: 'Acc_bDuctSupplyTemperature',
        ACC_BDUCTSUPPLYTEMPERATURE_CONTROLTYPE_VISIBLE: 'Acc_bDuctSupplyTemperature.CONTROLTYPE.VISIBLE',
        ACC_BEDGEPROBYPASSDAMPER: 'Acc_bEdgeProBypassDamper',
        ACC_BEDGEPROHUMIDIMIZER: 'Acc_bEdgeProHumidiMiZer',
        ACC_BHORNORSTROBEANNUNCIATOR: 'Acc_bHornOrStrobeAnnunciator',
        ACC_BHORNORSTROBEANNUNCIATOR_CONTROLTYPE_VISIBLE: 'Acc_bHornOrStrobeAnnunciator.CONTROLTYPE.VISIBLE',
        ACC_BLOUVEREDHAILGUARD: 'Acc_bLouveredHailGuard',
        ACC_BLOWSOUNDINDIVIDUALCOMPRESSOR: 'Acc_bLowSoundIndividualCompressor',
        ACC_BLOWSOUNDINDIVIDUALCOMPRESSOR_CONTROLTYPE_VISIBLE: 'Acc_bLowSoundIndividualCompressor.CONTROLTYPE.VISIBLE',
        ACC_BPLUGGEDFILTER: 'Acc_bPluggedFilter',
        ACC_BPOWEREXHAUSTHICAP1: 'Acc_bPowerExhaustHiCap1',
        ACC_BPOWEREXHAUSTHICAP2: 'Acc_bPowerExhaustHiCap2',
        ACC_BPOWEREXHAUSTHICAP3: 'Acc_bPowerExhaustHiCap3',
        ACC_BPOWEREXHAUSTMULTISTAGE: 'Acc_bPowerExhaustMultiStage',
        ACC_BRETURNAIRSMOKEDETECTOR: 'Acc_bReturnAirSmokeDetector',
        ACC_BRHSPACESENSOR: 'Acc_bRHSpaceSensor',
        ACC_BRHSPACESENSOR_CONTROLTYPE_VISIBLE: 'Acc_bRHSpaceSensor.CONTROLTYPE.VISIBLE',
        ACC_BROOFCURBS: 'Acc_bRoofCurbs',
        ACC_BSMOKEDETECTOR: 'Acc_bSmokeDetector',
        ACC_BSMOKEDETECTOR_CONTROLTYPE_VISIBLE: 'Acc_bSmokeDetector.CONTROLTYPE.VISIBLE',
        ACC_BSMOKEDETECTORREMOTE: 'Acc_bSmokeDetectorRemote',
        ACC_BSMOKEDETECTORREMOTE_CONTROLTYPE_VISIBLE: 'Acc_bSmokeDetectorRemote.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPC02ROOMSENSOR: 'Acc_bSpaceTempC02RoomSensor',
        ACC_BSPACETEMPC02ROOMSENSOR_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempC02RoomSensor.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPC02ROOMSENSORSETPOINT: 'Acc_bSpaceTempC02RoomSensorSetPoint',
        ACC_BSPACETEMPLCDDISPLAY: 'Acc_bSpaceTempLCDDisplay',
        ACC_BSPACETEMPLCDDISPLAY_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempLCDDisplay.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPOVERRIDEBUTTON: 'Acc_bSpaceTempOverrideButton',
        ACC_BSPACETEMPOVERRIDEBUTTON_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempOverrideButton.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPSLIDEBAR: 'Acc_bSpaceTempSlideBar',
        ACC_BSPACETEMPSLIDEBAR_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempSlideBar.CONTROLTYPE.VISIBLE',
        ACC_BSUPPLYSMOKEDETECTOR: 'Acc_bSupplySmokeDetector',
        ACC_BSUPPLYSMOKEDETECTOR_CONTROLTYPE_VISIBLE: 'Acc_bSupplySmokeDetector.CONTROLTYPE.VISIBLE',
        ACC_BTOUCHNGO2STAGE: 'Acc_bTouchNGo2Stage',
        ACC_BUVCBULBKIT: 'Acc_bUVCBulbKit',
        ACC_BVFDDISPLAYKIT: 'Acc_bVFDDisplayKit',
        ACC_BVFDDISPLAYKIT_CONTROLTYPE_VISIBLE: 'Acc_bVFDDisplayKit.CONTROLTYPE.VISIBLE',
        ACC_SCATEGORY: 'Acc_sCategory',
        WAR_SCATEGORY: 'War_sCategory',
        ACC_BFLUEKITEXTENSIONKIT: 'Acc_bFlueKitExtensionKit',
        ACC_BLPCONVERSIONKIT: 'Acc_bLPConversionKit',
        ACC_B12INCHMERV14SYNTHETICCARTRIDGEFILTERKIT: 'Acc_b12InchMERV14SyntheticCartridgeFilterKit',
        ACC_B2INCHMERV8FILTERBAGCARTR: 'Acc_b2InchMERV8FilterBagCartr',
        ACC_BFILTERHOOK: 'Acc_bFilterHook',
        ACC_BFILTERHOOK_CONTROLTYPE_VISIBLE: 'Acc_bFilterHook.CONTROLTYPE.VISIBLE',
        ACC_BHUMIDISTAT: 'Acc_bHumidistat',
        ACC_BLPCONVERSIONANDHIGHELEVATIONKIT: 'Acc_bLPConversionandHighElevationKit',
        ACC_BLPCONVERSIONANDHIGHELEVATIONKIT_CONTROLTYPE_VISIBLE: 'Acc_bLPConversionandHighElevationKit.CONTROLTYPE.VISIBLE',
        ACC_BNGHIGHELEVATIONKIT: 'Acc_bNGHighElevationKit',
        ACC_BNGHIGHELEVATIONKIT_CONTROLTYPE_VISIBLE: 'Acc_bNGHighElevationKit.CONTROLTYPE.VISIBLE',
        ACC_BROOFCURBCONVERSIONKIT: 'Acc_bRoofCurbConversionKit',
        ACC_BSUPPLYANDRETURNTOOLSCREEN: 'Acc_bSupplyandReturnToolScreen',
        ACC_BSUPPLYANDRETURNTOOLSCREEN_CONTROLTYPE_VISIBLE: 'Acc_bSupplyandReturnToolScreen.CONTROLTYPE.VISIBLE',
        ACC_BUVCEMITTERKIT: 'Acc_bUVCEmitterKit',
        ACC_BUVCEMITTERKIT_CONTROLTYPE_VISIBLE: 'Acc_bUVCEmitterKit.CONTROLTYPE.VISIBLE',
    },
    [TAGS.UI]: {
        ACC_B20AMPNONPOWERED: 'Acc_b20AmpNonPowered',
        ACC_B20AMPNONPOWERED_CONTROLTYPE_VISIBLE: 'Acc_b20AmpNonPowered.CONTROLTYPE.VISIBLE',
        ACC_B2INCHMERV8FILTERKIT: 'Acc_b2InchMERV8FilterKit',
        ACC_B4INCHCOMMERCIALTHERMOSTAT: 'Acc_b4InchCommercialThermostat',
        ACC_B4INCHCOMMERCIALTHERMOSTAT_CONTROLTYPE_VISIBLE: 'Acc_b4InchCommercialThermostat.CONTROLTYPE.VISIBLE',
        ACC_B4INCHMERV13FILTERKIT: 'Acc_b4InchMERV13FilterKit',
        ACC_B4INCHMERV8CARBONFILTERKIT: 'Acc_b4InchMERV8CarbonFilterKit',
        ACC_B4INCHMERV8FILTERKIT: 'Acc_b4InchMERV8FilterKit',
        ACC_BASPIRATORBOX: 'Acc_bAspiratorBox',
        ACC_BASPIRATORBOX_CONTROLTYPE_VISIBLE: 'Acc_bAspiratorBox.CONTROLTYPE.VISIBLE',
        ACC_BBAROMETRICRELIEF: 'Acc_bBarometricRelief',
        ACC_BC02SPACETEMPNOLCD: 'Acc_bC02SpaceTempNoLCD',
        ACC_BC02SPACETEMPNOLCD_CONTROLTYPE_VISIBLE: 'Acc_bC02SpaceTempNoLCD.CONTROLTYPE.VISIBLE',
        ACC_BCARRIERTRANSLATORLOMWORKS: 'Acc_bCarrierTranslatorLomWorks',
        ACC_BCARRIERTRANSLATORLOMWORKS_CONTROLTYPE_VISIBLE: 'Acc_bCarrierTranslatorLomWorks.CONTROLTYPE.VISIBLE',
        ACC_BCARRIERTRANSLATORMODBUS: 'Acc_bCarrierTranslatorModbus',
        ACC_BCARRIERTRANSLATORMODBUS_CONTROLTYPE_VISIBLE: 'Acc_bCarrierTranslatorModbus.CONTROLTYPE.VISIBLE',
        ACC_BCOMFORT2STAGE: 'Acc_bComfort2Stage',
        ACC_BCOMFORT2STAGE_CONTROLTYPE_VISIBLE: 'Acc_bComfort2Stage.CONTROLTYPE.VISIBLE',
        ACC_BCOMMERCIALTHERMOSTAT: 'Acc_bCommercialThermostat',
        ACC_BCOMMERCIALTHERMOSTAT_CONTROLTYPE_VISIBLE: 'Acc_bCommercialThermostat.CONTROLTYPE.VISIBLE',
        ACC_BCOMPRESSORSOUNDBLANKET: 'Acc_bCompressorSoundBlanket',
        ACC_BDUCTSUPPLYTEMPERATURE: 'Acc_bDuctSupplyTemperature',
        ACC_BDUCTSUPPLYTEMPERATURE_CONTROLTYPE_VISIBLE: 'Acc_bDuctSupplyTemperature.CONTROLTYPE.VISIBLE',
        ACC_BEDGEPROBYPASSDAMPER: 'Acc_bEdgeProBypassDamper',
        ACC_BEDGEPROHUMIDIMIZER: 'Acc_bEdgeProHumidiMiZer',
        ACC_BHORNORSTROBEANNUNCIATOR: 'Acc_bHornOrStrobeAnnunciator',
        ACC_BHORNORSTROBEANNUNCIATOR_CONTROLTYPE_VISIBLE: 'Acc_bHornOrStrobeAnnunciator.CONTROLTYPE.VISIBLE',
        ACC_BLOUVEREDHAILGUARD: 'Acc_bLouveredHailGuard',
        ACC_BLOWSOUNDINDIVIDUALCOMPRESSOR: 'Acc_bLowSoundIndividualCompressor',
        ACC_BLOWSOUNDINDIVIDUALCOMPRESSOR_CONTROLTYPE_VISIBLE: 'Acc_bLowSoundIndividualCompressor.CONTROLTYPE.VISIBLE',
        ACC_BPLUGGEDFILTER: 'Acc_bPluggedFilter',
        ACC_BPOWEREXHAUSTHICAP1: 'Acc_bPowerExhaustHiCap1',
        ACC_BPOWEREXHAUSTHICAP2: 'Acc_bPowerExhaustHiCap2',
        ACC_BPOWEREXHAUSTHICAP3: 'Acc_bPowerExhaustHiCap3',
        ACC_BPOWEREXHAUSTMULTISTAGE: 'Acc_bPowerExhaustMultiStage',
        ACC_BRETURNAIRSMOKEDETECTOR: 'Acc_bReturnAirSmokeDetector',
        ACC_BRHSPACESENSOR: 'Acc_bRHSpaceSensor',
        ACC_BRHSPACESENSOR_CONTROLTYPE_VISIBLE: 'Acc_bRHSpaceSensor.CONTROLTYPE.VISIBLE',
        ACC_BROOFCURBS: 'Acc_bRoofCurbs',
        ACC_BSMOKEDETECTOR: 'Acc_bSmokeDetector',
        ACC_BSMOKEDETECTOR_CONTROLTYPE_VISIBLE: 'Acc_bSmokeDetector.CONTROLTYPE.VISIBLE',
        ACC_BSMOKEDETECTORREMOTE: 'Acc_bSmokeDetectorRemote',
        ACC_BSMOKEDETECTORREMOTE_CONTROLTYPE_VISIBLE: 'Acc_bSmokeDetectorRemote.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPC02ROOMSENSOR: 'Acc_bSpaceTempC02RoomSensor',
        ACC_BSPACETEMPC02ROOMSENSOR_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempC02RoomSensor.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPC02ROOMSENSORSETPOINT: 'Acc_bSpaceTempC02RoomSensorSetPoint',
        ACC_BSPACETEMPLCDDISPLAY: 'Acc_bSpaceTempLCDDisplay',
        ACC_BSPACETEMPLCDDISPLAY_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempLCDDisplay.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPOVERRIDEBUTTON: 'Acc_bSpaceTempOverrideButton',
        ACC_BSPACETEMPOVERRIDEBUTTON_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempOverrideButton.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPSLIDEBAR: 'Acc_bSpaceTempSlideBar',
        ACC_BSPACETEMPSLIDEBAR_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempSlideBar.CONTROLTYPE.VISIBLE',
        ACC_BSUPPLYSMOKEDETECTOR: 'Acc_bSupplySmokeDetector',
        ACC_BSUPPLYSMOKEDETECTOR_CONTROLTYPE_VISIBLE: 'Acc_bSupplySmokeDetector.CONTROLTYPE.VISIBLE',
        ACC_BTOUCHNGO2STAGE: 'Acc_bTouchNGo2Stage',
        ACC_BUVCBULBKIT: 'Acc_bUVCBulbKit',
        ACC_BVFDDISPLAYKIT: 'Acc_bVFDDisplayKit',
        ACC_BVFDDISPLAYKIT_CONTROLTYPE_VISIBLE: 'Acc_bVFDDisplayKit.CONTROLTYPE.VISIBLE',
        ACC_SCATEGORY: 'Acc_sCategory',
        ACO_BSPECIFYBARRIER: 'ACO_bSpecifyBarrier',
        ACO_BSPECIFYREFLECTION: 'ACO_bSpecifyReflection',
        ACO_FHEIGHTBARRIER: 'ACO_fHeightBarrier',
        ACO_FHEIGHTBARRIER_DISPLAYUNIT: 'ACO_fHeightBarrier.DISPLAYUNIT',
        ACO_FHEIGHTBARRIER_UNIT: 'ACO_fHeightBarrier.UNIT',
        ACO_FHEIGHTRECEIVER: 'ACO_fHeightReceiver',
        ACO_FHEIGHTRECEIVER_DISPLAYUNIT: 'ACO_fHeightReceiver.DISPLAYUNIT',
        ACO_FHEIGHTRECEIVER_UNIT: 'ACO_fHeightReceiver.UNIT',
        ACO_FHEIGHTSOURCE: 'ACO_fHeightSource',
        ACO_FHEIGHTSOURCE_DISPLAYUNIT: 'ACO_fHeightSource.DISPLAYUNIT',
        ACO_FHEIGHTSOURCE_UNIT: 'ACO_fHeightSource.UNIT',
        ACO_FHORZDISTANCERECEIVER: 'ACO_fHorzDistanceReceiver',
        ACO_FHORZDISTANCERECEIVER_DISPLAYUNIT: 'ACO_fHorzDistanceReceiver.DISPLAYUNIT',
        ACO_FHORZDISTANCERECEIVER_UNIT: 'ACO_fHorzDistanceReceiver.UNIT',
        ACO_FHORZDISTANCERECEIVERBARR: 'ACO_fHorzDistanceReceiverBarr',
        ACO_FHORZDISTANCERECEIVERBARR_DISPLAYUNIT: 'ACO_fHorzDistanceReceiverBarr.DISPLAYUNIT',
        ACO_FHORZDISTANCERECEIVERBARR_UNIT: 'ACO_fHorzDistanceReceiverBarr.UNIT',
        ACO_FHORZDISTANCEUNITBARR: 'ACO_fHorzDistanceUnitBarr',
        ACO_FHORZDISTANCEUNITBARR_DISPLAYUNIT: 'ACO_fHorzDistanceUnitBarr.DISPLAYUNIT',
        ACO_FHORZDISTANCEUNITBARR_UNIT: 'ACO_fHorzDistanceUnitBarr.UNIT',
        ACO_SCATEGORY: 'ACO_sCategory',
        BU_SAPPLICATIONTYPE: 'BU_sApplicationType',
        BU_SHEATCAPACITY: 'BU_sHeatCapacity',
        BU_SHEATTYPE: 'BU_sHeatType',
        BU_SMODEL: 'BU_sModel',
        TAG_SCONFIGRULESET: 'Tag_sConfigRuleset',
        BU_SSUPPLYRETURN: 'BU_sSupplyReturn',
        BU_SUNITSIZE: 'BU_sUnitSize',
        BU_SVOLTAGE: 'BU_sVoltage',
        DC_BCHECKHUMIDIMIZERFORM: 'DC_bCheckHumidimizerForm',
        DC_BCHECKMAXCOOLING: 'DC_bCheckMaxCooling',
        DC_BCHECKMAXDEHUMIDIFICATION: 'DC_bCheckMaxDeHumidification',
        DC_BCHECKPARTLOADHUMIDIFICATION: 'DC_bCheckPartLoadHumidification',
        DC_BCOOLING: 'DC_bCooling',
        DC_BHEATING: 'DC_bHeating',
        DC_BHEATINGLAT: 'DC_bHeatingLAT',
        DC_BSENSIBLECOOLING: 'DC_bSensibleCooling',
        DC_FALTITUDEFT: 'DC_fAltitudeFt',
        DC_FALTITUDEFT_DISPLAYUNIT: 'DC_fAltitudeFt.DISPLAYUNIT',
        DC_FALTITUDEFT_UNIT: 'DC_fAltitudeFt.UNIT',
        DC_FCOOLING: 'DC_fCooling',
        DC_FCOOLING_DISPLAYUNIT: 'DC_fCooling.DISPLAYUNIT',
        DC_FCOOLING_UNIT: 'DC_fCooling.UNIT',
        DC_FEXTERNALSTATIC: 'DC_fExternalStatic',
        DC_FEXTERNALSTATIC_DISPLAYUNIT: 'DC_fExternalStatic.DISPLAYUNIT',
        DC_FEXTERNALSTATIC_UNIT: 'DC_fExternalStatic.UNIT',
        DC_FHEATING: 'DC_fHeating',
        DC_FHEATING_DISPLAYUNIT: 'DC_fHeating.DISPLAYUNIT',
        DC_FHEATING_UNIT: 'DC_fHeating.UNIT',
        DC_FHEATINGLAT: 'DC_fHeatingLAT',
        DC_FHEATINGLAT_DISPLAYUNIT: 'DC_fHeatingLAT.DISPLAYUNIT',
        DC_FHEATINGLAT_UNIT: 'DC_fHeatingLAT.UNIT',
        DC_FMAXDEHUMCONDENSERENTTEMP: 'DC_fMaxDeHumCondenserEntTemp',
        DC_FMAXDEHUMCONDENSERENTTEMP_DISPLAYUNIT: 'DC_fMaxDeHumCondenserEntTemp.DISPLAYUNIT',
        DC_FMAXDEHUMCONDENSERENTTEMP_UNIT: 'DC_fMaxDeHumCondenserEntTemp.UNIT',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB: 'DC_fMaxDeHumEvapEntTempDryBulb',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB_DISPLAYUNIT: 'DC_fMaxDeHumEvapEntTempDryBulb.DISPLAYUNIT',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB_UNIT: 'DC_fMaxDeHumEvapEntTempDryBulb.UNIT',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB: 'DC_fMaxDeHumEvapEntTempWetBulb',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB_DISPLAYUNIT: 'DC_fMaxDeHumEvapEntTempWetBulb.DISPLAYUNIT',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB_UNIT: 'DC_fMaxDeHumEvapEntTempWetBulb.UNIT',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING: 'DC_fMixedAir_EIC_DryBulbCooling',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fMixedAir_EIC_DryBulbCooling.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING_UNIT: 'DC_fMixedAir_EIC_DryBulbCooling.UNIT',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING: 'DC_fMixedAir_EIC_DryBulbHeating',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING_DISPLAYUNIT: 'DC_fMixedAir_EIC_DryBulbHeating.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING_UNIT: 'DC_fMixedAir_EIC_DryBulbHeating.UNIT',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING: 'DC_fMixedAir_EIC_WetBulbCooling',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING_DISPLAYUNIT: 'DC_fMixedAir_EIC_WetBulbCooling.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING_UNIT: 'DC_fMixedAir_EIC_WetBulbCooling.UNIT',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING: 'DC_fOutdoor_EOC_DryBulbCooling',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoor_EOC_DryBulbCooling.DISPLAYUNIT',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING_UNIT: 'DC_fOutdoor_EOC_DryBulbCooling.UNIT',
        DC_FOUTDOORAIR_DRYBULBCOOLING: 'DC_fOutdoorAir_DryBulbCooling',
        DC_FOUTDOORAIR_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoorAir_DryBulbCooling.DISPLAYUNIT',
        DC_FOUTDOORAIR_DRYBULBCOOLING_UNIT: 'DC_fOutdoorAir_DryBulbCooling.UNIT',
        DC_FOUTDOORAIR_DRYBULBHEATING: 'DC_fOutdoorAir_DryBulbHeating',
        DC_FOUTDOORAIR_DRYBULBHEATING_DISPLAYUNIT: 'DC_fOutdoorAir_DryBulbHeating.DISPLAYUNIT',
        DC_FOUTDOORAIR_DRYBULBHEATING_UNIT: 'DC_fOutdoorAir_DryBulbHeating.UNIT',
        DC_FOUTDOORAIR_WETBULBCOOLING: 'DC_fOutdoorAir_WetBulbCooling',
        DC_FOUTDOORAIR_WETBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoorAir_WetBulbCooling.DISPLAYUNIT',
        DC_FOUTDOORAIR_WETBULBCOOLING_UNIT: 'DC_fOutdoorAir_WetBulbCooling.UNIT',
        DC_FOUTDOORAIR_WETBULBHEATING: 'DC_fOutdoorAir_WetBulbHeating',
        DC_FOUTDOORAIR_WETBULBHEATING_DISPLAYUNIT: 'DC_fOutdoorAir_WetBulbHeating.DISPLAYUNIT',
        DC_FOUTDOORAIR_WETBULBHEATING_UNIT: 'DC_fOutdoorAir_WetBulbHeating.UNIT',
        DC_FOUTDOORAIRCFM: 'DC_fOutdoorAirCFM',
        DC_FOUTDOORAIRCFM_DISPLAYUNIT: 'DC_fOutdoorAirCFM.DISPLAYUNIT',
        DC_FOUTDOORAIRCFM_UNIT: 'DC_fOutdoorAirCFM.UNIT',
        DC_FPLCONDENSERENTTEMP: 'DC_fPLCondenserEntTemp',
        DC_FPLCONDENSERENTTEMP_DISPLAYUNIT: 'DC_fPLCondenserEntTemp.DISPLAYUNIT',
        DC_FPLCONDENSERENTTEMP_UNIT: 'DC_fPLCondenserEntTemp.UNIT',
        DC_FPLEVAPENTTEMPDRYBULB: 'DC_fPLEvapEntTempDryBulb',
        DC_FPLEVAPENTTEMPDRYBULB_DISPLAYUNIT: 'DC_fPLEvapEntTempDryBulb.DISPLAYUNIT',
        DC_FPLEVAPENTTEMPDRYBULB_UNIT: 'DC_fPLEvapEntTempDryBulb.UNIT',
        DC_FPLEVAPENTTEMPWETBULB: 'DC_fPLEvapEntTempWetBulb',
        DC_FPLEVAPENTTEMPWETBULB_DISPLAYUNIT: 'DC_fPLEvapEntTempWetBulb.DISPLAYUNIT',
        DC_FPLEVAPENTTEMPWETBULB_UNIT: 'DC_fPLEvapEntTempWetBulb.UNIT',
        DC_FPOWEREXHAUSTAIRFLOW: 'DC_fPowerExhaustAirFlow',
        DC_FPOWEREXHAUSTAIRFLOW_DISPLAYUNIT: 'DC_fPowerExhaustAirFlow.DISPLAYUNIT',
        DC_FPOWEREXHAUSTAIRFLOW_UNIT: 'DC_fPowerExhaustAirFlow.UNIT',
        DC_FRETURNAIR_DRYBULBCOOLING: 'DC_fReturnAir_DryBulbCooling',
        DC_FRETURNAIR_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fReturnAir_DryBulbCooling.DISPLAYUNIT',
        DC_FRETURNAIR_DRYBULBCOOLING_UNIT: 'DC_fReturnAir_DryBulbCooling.UNIT',
        DC_FRETURNAIR_DRYBULBHEATING: 'DC_fReturnAir_DryBulbHeating',
        DC_FRETURNAIR_DRYBULBHEATING_DISPLAYUNIT: 'DC_fReturnAir_DryBulbHeating.DISPLAYUNIT',
        DC_FRETURNAIR_DRYBULBHEATING_UNIT: 'DC_fReturnAir_DryBulbHeating.UNIT',
        DC_FRETURNAIR_WETBULBCOOLING: 'DC_fReturnAir_WetBulbCooling',
        DC_FRETURNAIR_WETBULBCOOLING_DISPLAYUNIT: 'DC_fReturnAir_WetBulbCooling.DISPLAYUNIT',
        DC_FRETURNAIR_WETBULBCOOLING_UNIT: 'DC_fReturnAir_WetBulbCooling.UNIT',
        DC_FRETURNAIR_WETBULBHEATING: 'DC_fReturnAir_WetBulbHeating',
        DC_FRETURNAIR_WETBULBHEATING_DISPLAYUNIT: 'DC_fReturnAir_WetBulbHeating.DISPLAYUNIT',
        DC_FRETURNAIR_WETBULBHEATING_UNIT: 'DC_fReturnAir_WetBulbHeating.UNIT',
        DC_FSENSIBLECOOLING: 'DC_fSensibleCooling',
        DC_FSENSIBLECOOLING_DISPLAYUNIT: 'DC_fSensibleCooling.DISPLAYUNIT',
        DC_FSENSIBLECOOLING_UNIT: 'DC_fSensibleCooling.UNIT',
        DC_FSUPPLYAIRFLOW: 'DC_fSupplyAirFlow',
        DC_FSUPPLYAIRFLOW_DISPLAYUNIT: 'DC_fSupplyAirFlow.DISPLAYUNIT',
        DC_FSUPPLYAIRFLOW_UNIT: 'DC_fSupplyAirFlow.UNIT',
        DC_FSUPPLYHEATINGAIRFLOW: 'DC_fSupplyHeatingAirFlow',
        DC_FSUPPLYHEATINGAIRFLOW_DISPLAYUNIT: 'DC_fSupplyHeatingAirFlow.DISPLAYUNIT',
        DC_FSUPPLYHEATINGAIRFLOW_UNIT: 'DC_fSupplyHeatingAirFlow.UNIT',
        DC_SCOILCONDITIONMETHOD: 'DC_sCoilConditionMethod',
        WEA_IN_SLOCATION: 'Wea_In_sLocation',
        WEA_IN_SCITY: 'Wea_In_sCity',
        MLP_ACC_FTOTAL: 'MLP_Acc_fTotal',
        MLP_BU_FTOTAL: 'MLP_BU_fTotal',
        MLP_BU_SAPPLICATIONTYPE: 'MLP_BU_sApplicationType',
        MLP_BU_SHEATCAPACITY: 'MLP_BU_sHeatCapacity',
        MLP_FBASEUNIT: 'MLP_fBaseUnit',
        MLP_FOPT_BBOTTOMCONSTRUCTION: 'MLP_fOPT_bBottomConstruction',
        MLP_FOPT_BCONDENSEOVERFLOWSWITCH: 'MLP_fOPT_bCondenseOverflowSwitch',
        MLP_FOPT_BDIGITALCOMPRESSOR: 'MLP_fOpt_bDigitalCompressor',
        MLP_FOPT_BDRAINPANTYPES: 'MLP_fOPT_bDrainPanTypes',
        MLP_FOPT_BHAILGUARD: 'MLP_fOPT_bHailGuard',
        MLP_FOPT_BHUMIDIMIZER: 'MLP_fOPT_bHumidimizer',
        MLP_FOPT_BHUMIDITYSENSORS: 'MLP_fOPT_bHumiditySensors',
        MLP_FOPT_BIAQOPTIONS: 'MLP_fOPT_bIAQOptions',
        MLP_FOPT_BLOWAMBIENT: 'MLP_fOPT_bLowAmbient',
        MLP_FOPT_BLOWSOUNDCNDFANS: 'MLP_fOPT_bLowSoundCndFans',
        MLP_FOPT_BMOTORPROTECTION: 'MLP_fOpt_bMotorProtection',
        MLP_FOPT_BNONFUSEDDISCONNECT: 'MLP_fOPT_bNonFusedDisconnect',
        MLP_FOPT_BOUTDOORAIRMEASURE: 'MLP_fOPT_bOutdoorAirMeasure',
        MLP_FOPT_BPHASEMONITOR: 'MLP_fOPT_bPhaseMonitor',
        MLP_FOPT_BREFRIGERANTRELIEFVALUE: 'MLP_fOPT_bRefrigerantReliefValue',
        MLP_FOPT_BRETURNAIRCO2SENSOR: 'MLP_fOPT_bReturnAirCO2Sensor',
        MLP_FOPT_BRETURNAIRSMOKEDETECTOR: 'MLP_fOPT_bReturnAirSmokeDetector',
        MLP_FOPT_BSERVICEPACK: 'MLP_fOPT_bServicePack',
        MLP_FOPT_BSUPPLYFANMOTOR: 'MLP_fOpt_bSupplyFanMotor',
        MLP_FOPT_BTERMINALBLOCK: 'MLP_fOPT_bTerminalBlock',
        MLP_FOPT_BVFDBYPASS: 'MLP_fOpt_bVfdBypass',
        MLP_FOPT_SCOILFINCOATING: 'MLP_fOpt_sCoilFinCoating',
        MLP_FOPT_SCONSTRUCTION: 'MLP_fOPT_sConstruction',
        MLP_FOPT_SCONVENIENCEOUTLET: 'MLP_fOpt_sConvenienceOutlet',
        MLP_FOPT_SHEATOPTION: 'MLP_fOPT_sHeatOption',
        MLP_FOPT_SOUTDOORAIR: 'MLP_fOpt_sOutdoorAir',
        MLP_FOPT_SPREFILTERMSTYPES: 'MLP_fOPT_sPreFilterMSTypes',
        MLP_FOPT_SPREFILTERTYPES: 'MLP_fOPT_sPreFilterTypes',
        MLP_FOPT_SRELIEFTYPE: 'MLP_fOPT_sReliefType',
        MLP_FOPT_SSCCR: 'MLP_fOPT_sSCCR',
        MLP_FOPT_SSUPPLYFANMOTORSIZE: 'MLP_fOpt_sSupplyFanMotorSize',
        MLP_FOPT_SUNITEFFICIENCY: 'MLP_fOpt_sUnitEfficiency',
        MLP_FTOTAL: 'MLP_fTotal',
        MLP_OPT_FTOTAL: 'MLP_Opt_fTotal',
        MLP_QC_FTOTAL: 'MLP_QC_fTotal',
        MLP_STARTUP_FTOTAL: 'MLP_Startup_fTotal',
        MLP_WAR_FTOTAL: 'MLP_War_fTotal',
        OPT_BAUTOSELECTSUPPLYFANMOTORSIZE: 'OPT_bAutoSelectSupplyFanMotorSize',
        OPT_BBOTTOMCONSTRUCTION: 'OPT_bBottomConstruction',
        OPT_BCONDENSEOVERFLOWSWITCH: 'OPT_bCondenseOverflowSwitch',
        OPT_BDIGITALCOMPRESSOR: 'Opt_bDigitalCompressor',
        OPT_BDRAINPANTYPES: 'OPT_bDrainPanTypes',
        OPT_BHAILGUARD: 'OPT_bHailGuard',
        OPT_BHUMIDIMIZER: 'OPT_bHumidimizer',
        OPT_BHUMIDIMIZER_CHILDREN: 'OPT_bHumidimizer.CHILDREN',
        OPT_BHUMIDITYSENSORS: 'OPT_bHumiditySensors',
        OPT_BIAQOPTIONS: 'OPT_bIAQOptions',
        OPT_BLOWAMBIENT: 'OPT_bLowAmbient',
        OPT_BLOWSOUNDCNDFANS: 'OPT_bLowSoundCndFans',
        OPT_BMOTORPROTECTION: 'Opt_bMotorProtection',
        OPT_BNONFUSEDDISCONNECT: 'OPT_bNonFusedDisconnect',
        OPT_BPHASEMONITOR: 'OPT_bPhaseMonitor',
        OPT_BREFRIGERANTRELIEFVALUE: 'OPT_bRefrigerantReliefValue',
        OPT_BRETURNAIRCO2SENSOR: 'OPT_bReturnAirCO2Sensor',
        OPT_BRETURNAIRSMOKEDETECTOR: 'OPT_bReturnAirSmokeDetector',
        OPT_BSERVICEPACK: 'OPT_bServicePack',
        OPT_BSUPPLYFANMOTOR: 'Opt_bSupplyFanMotor',
        OPT_BTERMINALBLOCK: 'OPT_bTerminalBlock',
        OPT_BVFDBYPASS: 'Opt_bVfdBypass',
        OPT_NONFUSEDDISCONNECT_NOTE: 'OPT_Nonfuseddisconnect_Note',
        OPT_SCATEGORY: 'Opt_sCategory',
        OPT_SCOILFINCOATING: 'Opt_sCoilFinCoating',
        OPT_SCONSTRUCTION: 'OPT_sConstruction',
        OPT_SCONVENIENCEOUTLET: 'Opt_sConvenienceOutlet',
        OPT_SHEATOPTION: 'OPT_sHeatOption',
        OPT_SOUTDOORAIR: 'Opt_sOutdoorAir',
        OPT_SPREFILTERMSTYPES: 'OPT_sPreFilterMSTypes',
        OPT_SPREFILTERTYPES: 'OPT_sPreFilterTypes',
        OPT_SRELIEFTYPE: 'OPT_sReliefType',
        OPT_SRELIEFTYPE_CHILDREN: 'OPT_sReliefType.CHILDREN',
        OPT_SSCCR: 'OPT_sSCCR',
        OPT_SSCCR_NOTE: 'OPT_sSCCR_Note',
        OPT_SSUPPLYFANMOTORSIZE: 'Opt_sSupplyFanMotorSize',
        OPT_SSUPPLYFANMOTORSIZE_CHILDREN: 'Opt_sSupplyFanMotorSize.CHILDREN',
        OPT_SUNITEFFICIENCY: 'Opt_sUnitEfficiency',
        PC_IN_BHASLOWLOADMCHXRESTRICTION: 'PC_In_bHasLowLoadMCHXRestriction',
        PC_IN_BLOCALCORROSIVEENV: 'PC_In_bLocalCorrosiveEnv',
        PC_IN_SCOUNTRYCODE: 'PC_In_sCountryCode',
        PC_IN_SPOSTALCODE: 'PC_In_sPostalCode',
        PC_OUT_BCOILCOATINGREQUIRED: 'PC_Out_bCoilCoatingRequired',
        PC_OUT_BPOSTALCODEVALIDITY: 'PC_Out_bPostalCodeValidity',
        PN_SMODEL: 'PN_sModel',
        QP_SBASEUNIT: 'QP_sBaseUnit',
        STARTUP_BADDITIONALUNITCOOLING: 'StartUp_bAdditionalUnitCooling',
        STARTUP_BADDITIONALUNITHEATING: 'StartUp_bAdditionalUnitHeating',
        STARTUP_BFIRSTUNITCOOLING: 'StartUp_bFirstUnitCooling',
        STARTUP_BFIRSTUNITHEATING: 'StartUp_bFirstUnitHeating',
        STARTUP_SCATEGORY: 'StartUp_sCategory',
        TAG_BCONFIGVALID: 'Tag_bConfigValid',
        TAG_NQTY: 'Tag_nQty',
        UI_CONFIG_VALID: 'UI_Config.VALID',
        UI_CONFIG_UNIT_VALID: 'UI_Config_Unit.VALID',
        UI_CONFIG_UNIT_ACCESSORIES_VALID: 'UI_Config_Unit_Accessories.VALID',
        UI_CONFIG_UNIT_ACO_VALID: 'UI_Config_Unit_ACO.VALID',
        UI_CONFIG_UNIT_OPTIONS_VALID: 'UI_Config_Unit_Options.VALID',
        UI_CONFIG_UNIT_PC_VALID: 'UI_Config_Unit_PC.VALID',
        UI_CONFIG_UNIT_STARTUP_VALID: 'UI_Config_Unit_Startup.VALID',
        UI_CONFIG_UNIT_WARRANTIES_VALID: 'UI_Config_Unit_Warranties.VALID',
        UI_REPORTS_VALID: 'UI_Reports.VALID',
        UI_SEL_VALID: 'UI_Sel.VALID',
        UI_SEL_DC_VALID: 'UI_Sel_DC.VALID',
        UI_SEL_DC_CAPREQ_VALID: 'UI_Sel_DC_CapReq.VALID',
        UI_SEL_DC_COILCOND_VALID: 'UI_Sel_DC_CoilCond.VALID',
        UI_SEL_DC_HOTWATER_VALID: 'UI_Sel_DC_HotWater.VALID',
        UI_SEL_DC_UNIT_VALID: 'UI_Sel_DC_Unit.VALID',
        UI_SEL_REQ_VALID: 'UI_Sel_Req.VALID',
        UI_SEL_REQ_AIRFLOW_VALID: 'UI_Sel_REQ_AIRFLOW.VALID',
        UI_SEL_REQ_MODEL_VALID: 'UI_Sel_Req_Model.VALID',
        UI_SEL_REQ_REQ_VALID: 'UI_Sel_Req_Req.VALID',
        UI_USER_VALID: 'UI_User.VALID',
        WAR_B1STYEARCARRIERCCSLABOR: 'War_b1stYearCarrierCCSLabor',
        WAR_BCOMPLETE2YEARPARTSANDLABOR: 'War_bComplete2YearPartsAndLabor',
        WAR_BCOMPLETE2YEARPARTSONLY: 'War_bComplete2YearPartsOnly',
        WAR_BCOMPLETE3YEARPARTSANDLABOR: 'War_bComplete3YearPartsAndLabor',
        WAR_BCOMPLETE3YEARPARTSONLY: 'War_bComplete3YearPartsOnly',
        WAR_BCOMPLETE4YEARPARTSANDLABOR: 'War_bComplete4YearPartsAndLabor',
        WAR_BCOMPLETE4YEARPARTSONLY: 'War_bComplete4YearPartsOnly',
        WAR_BCOMPLETE5YEARPARTSANDLABOR: 'War_bComplete5YearPartsAndLabor',
        WAR_BCOMPLETE5YEARPARTSONLY: 'War_bComplete5YearPartsOnly',
        WAR_BCOMPRESSOR2YEARPARTSANDLABOR: 'War_bCompressor2YearPartsAndLabor',
        WAR_BCOMPRESSOR2YEARPARTSONLY: 'War_bCompressor2YearPartsOnly',
        WAR_BCOMPRESSOR3YEARPARTSANDLABOR: 'War_bCompressor3YearPartsAndLabor',
        WAR_BCOMPRESSOR3YEARPARTSONLY: 'War_bCompressor3YearPartsOnly',
        WAR_BCOMPRESSOR4YEARPARTSANDLABOR: 'War_bCompressor4YearPartsAndLabor',
        WAR_BCOMPRESSOR4YEARPARTSONLY: 'War_bCompressor4YearPartsOnly',
        WAR_BCOMPRESSOR5YEARPARTSANDLABOR: 'War_bCompressor5YearPartsAndLabor',
        WAR_BCOMPRESSOR5YEARPARTSONLY: 'War_bCompressor5YearPartsOnly',
        WAR_SCATEGORY: 'War_sCategory',
        ACC_BFLUEKITEXTENSIONKIT: 'Acc_bFlueKitExtensionKit',
        ACC_BLPCONVERSIONKIT: 'Acc_bLPConversionKit',
        MLP_FOPT_BSTAINLESSSTEEL_EXCHANGER: 'MLP_fOPT_bStainlessSteel_Exchanger',
        OPT_BSTAINLESSSTEEL_EXCHANGER: 'OPT_bStainlessSteel_Exchanger',
        WAR_BALGASHEATEXCHANGERPARTSONLY: 'War_bALGasHeatExchangerPartsOnly',
        WAR_BSSGASHEATEXCHANGERPARTSONLY: 'War_bSSGasHeatExchangerPartsOnly',
        ACC_B12INCHMERV14SYNTHETICCARTRIDGEFILTERKIT: 'Acc_b12InchMERV14SyntheticCartridgeFilterKit',
        ACC_B2INCHMERV8FILTERBAGCARTR: 'Acc_b2InchMERV8FilterBagCartr',
        ACC_BFILTERHOOK: 'Acc_bFilterHook',
        ACC_BFILTERHOOK_CONTROLTYPE_VISIBLE: 'Acc_bFilterHook.CONTROLTYPE.VISIBLE',
        ACC_BHUMIDISTAT: 'Acc_bHumidistat',
        ACC_BLPCONVERSIONANDHIGHELEVATIONKIT: 'Acc_bLPConversionandHighElevationKit',
        ACC_BLPCONVERSIONANDHIGHELEVATIONKIT_CONTROLTYPE_VISIBLE: 'Acc_bLPConversionandHighElevationKit.CONTROLTYPE.VISIBLE',
        ACC_BNGHIGHELEVATIONKIT: 'Acc_bNGHighElevationKit',
        ACC_BNGHIGHELEVATIONKIT_CONTROLTYPE_VISIBLE: 'Acc_bNGHighElevationKit.CONTROLTYPE.VISIBLE',
        ACC_BROOFCURBCONVERSIONKIT: 'Acc_bRoofCurbConversionKit',
        ACC_BSUPPLYANDRETURNTOOLSCREEN: 'Acc_bSupplyandReturnToolScreen',
        ACC_BSUPPLYANDRETURNTOOLSCREEN_CONTROLTYPE_VISIBLE: 'Acc_bSupplyandReturnToolScreen.CONTROLTYPE.VISIBLE',
        ACC_BUVCEMITTERKIT: 'Acc_bUVCEmitterKit',
        ACC_BUVCEMITTERKIT_CONTROLTYPE_VISIBLE: 'Acc_bUVCEmitterKit.CONTROLTYPE.VISIBLE',
        DC_FHOTWATERENTERINGFLUIDTEMP: 'DC_fHotWaterEnteringFluidTemp',
        DC_FHOTWATERENTERINGFLUIDTEMP_DISPLAYUNIT: 'DC_fHotWaterEnteringFluidTemp.DISPLAYUNIT',
        DC_FHOTWATERENTERINGFLUIDTEMP_UNIT: 'DC_fHotWaterEnteringFluidTemp.UNIT',
        DC_FHOTWATERFLOWRATE: 'DC_fHotWaterFlowRate',
        DC_FHOTWATERFLOWRATE_DISPLAYUNIT: 'DC_fHotWaterFlowRate.DISPLAYUNIT',
        DC_FHOTWATERFLOWRATE_UNIT: 'DC_fHotWaterFlowRate.UNIT',
        DC_FHOTWATERTEMPDROP: 'DC_fHotWaterTempDrop',
        DC_FHOTWATERTEMPDROP_DISPLAYUNIT: 'DC_fHotWaterTempDrop.DISPLAYUNIT',
        DC_FHOTWATERTEMPDROP_UNIT: 'DC_fHotWaterTempDrop.UNIT',
        DC_SHOTWATERFLOWRATE: 'DC_sHotWaterFlowRate',
        DC_SHOTWATERFLUID: 'DC_sHotwaterFluid',
        DC_SHOTWATERVALVETYPE: 'DC_sHotwaterValveType',
        MLP_FOPT_BBAROMETRICRELIEF: 'MLP_fOPT_bBarometricRelief',
        MLP_FOPT_BEXTENDEDSECTION: 'MLP_fOPT_bExtendedSection',
        MLP_FOPT_BLOWSTATICEXHAUSTFAN: 'MLP_fOPT_bLowStaticExhaustFan',
        MLP_FOPT_BMEDSTATICEXHAUSTFAN: 'MLP_fOPT_bMedStaticExhaustFan',
        MLP_FOPT_BMODULATINGBPCONTROL: 'MLP_fOPT_bModulatingBPControl',
        MLP_FOPT_BOPTIONALCONTROLS: 'MLP_fOPT_bOptionalControls',
        MLP_FOPT_BOUTDOORAIRFLOW: 'MLP_fOPT_bOutdoorAirflow',
        MLP_FOPT_BPLENUMSECTION: 'MLP_fOPT_bPlenumSection',
        MLP_FOPT_BSTDSTATICEXHAUSTFAN: 'MLP_fOPT_bStdStaticExhaustFan',
        MLP_FOPT_SCHASSIS: 'MLP_fOpt_sChassis',
        MLP_FOPT_SMOTORSTATIC: 'MLP_fOPT_sMotorStatic',
        MLP_FOPT_SSOUNDOPTION: 'MLP_fOPT_sSoundOption',
        OPT_BBAROMETRICRELIEF: 'OPT_bBarometricRelief',
        OPT_BEXTENDEDSECTION: 'OPT_bExtendedSection',
        OPT_BLOWSTATICEXHAUSTFAN: 'OPT_bLowStaticExhaustFan',
        OPT_BLOWSTATICEXHAUSTFAN_CHILDREN: 'OPT_bLowStaticExhaustFan.CHILDREN',
        OPT_BLOWSTATICEXHAUSTFAN_CONTROLTYPE_VALID: 'OPT_bLowStaticExhaustFan.CONTROLTYPE.VALID',
        OPT_BMEDSTATICEXHAUSTFAN: 'OPT_bMedStaticExhaustFan',
        OPT_BMEDSTATICEXHAUSTFAN_CHILDREN: 'OPT_bMedStaticExhaustFan.CHILDREN',
        OPT_BMODULATINGBPCONTROL: 'OPT_bModulatingBPControl',
        OPT_BOUTDOORAIRFLOW: 'OPT_bOutdoorAirflow',
        OPT_BSTDSTATICEXHAUSTFAN: 'OPT_bStdStaticExhaustFan',
        OPT_BSTDSTATICEXHAUSTFAN_CHILDREN: 'OPT_bStdStaticExhaustFan.CHILDREN',
        OPT_SCHASSIS: 'Opt_sChassis',
        OPT_SCOMPRESSOR: 'OPT_sCompressor',
        OPT_SMOTORSTATIC: 'OPT_sMotorStatic',
        OPT_SMOTORSTATIC_CHILDREN: 'OPT_sMotorStatic.CHILDREN',
        OPT_BPLENUMSECTION: 'OPT_bPlenumSection',
        DC_SCITY: 'DC_sCity',
        DC_SLOCATION: 'DC_sLocation',
    },
    [TAGS.UI_CONFIG_UNIT]: {
        ACC_B20AMPNONPOWERED: 'Acc_b20AmpNonPowered',
        ACC_B20AMPNONPOWERED_CONTROLTYPE_VISIBLE: 'Acc_b20AmpNonPowered.CONTROLTYPE.VISIBLE',
        ACC_B2INCHMERV8FILTERKIT: 'Acc_b2InchMERV8FilterKit',
        ACC_B4INCHCOMMERCIALTHERMOSTAT: 'Acc_b4InchCommercialThermostat',
        ACC_B4INCHCOMMERCIALTHERMOSTAT_CONTROLTYPE_VISIBLE: 'Acc_b4InchCommercialThermostat.CONTROLTYPE.VISIBLE',
        ACC_B4INCHMERV13FILTERKIT: 'Acc_b4InchMERV13FilterKit',
        ACC_B4INCHMERV8CARBONFILTERKIT: 'Acc_b4InchMERV8CarbonFilterKit',
        ACC_B4INCHMERV8FILTERKIT: 'Acc_b4InchMERV8FilterKit',
        ACC_BASPIRATORBOX: 'Acc_bAspiratorBox',
        ACC_BASPIRATORBOX_CONTROLTYPE_VISIBLE: 'Acc_bAspiratorBox.CONTROLTYPE.VISIBLE',
        ACC_BBAROMETRICRELIEF: 'Acc_bBarometricRelief',
        ACC_BC02SPACETEMPNOLCD: 'Acc_bC02SpaceTempNoLCD',
        ACC_BC02SPACETEMPNOLCD_CONTROLTYPE_VISIBLE: 'Acc_bC02SpaceTempNoLCD.CONTROLTYPE.VISIBLE',
        ACC_BCARRIERTRANSLATORLOMWORKS: 'Acc_bCarrierTranslatorLomWorks',
        ACC_BCARRIERTRANSLATORLOMWORKS_CONTROLTYPE_VISIBLE: 'Acc_bCarrierTranslatorLomWorks.CONTROLTYPE.VISIBLE',
        ACC_BCARRIERTRANSLATORMODBUS: 'Acc_bCarrierTranslatorModbus',
        ACC_BCARRIERTRANSLATORMODBUS_CONTROLTYPE_VISIBLE: 'Acc_bCarrierTranslatorModbus.CONTROLTYPE.VISIBLE',
        ACC_BCOMFORT2STAGE: 'Acc_bComfort2Stage',
        ACC_BCOMFORT2STAGE_CONTROLTYPE_VISIBLE: 'Acc_bComfort2Stage.CONTROLTYPE.VISIBLE',
        ACC_BCOMMERCIALTHERMOSTAT: 'Acc_bCommercialThermostat',
        ACC_BCOMMERCIALTHERMOSTAT_CONTROLTYPE_VISIBLE: 'Acc_bCommercialThermostat.CONTROLTYPE.VISIBLE',
        ACC_BCOMPRESSORSOUNDBLANKET: 'Acc_bCompressorSoundBlanket',
        ACC_BDUCTSUPPLYTEMPERATURE: 'Acc_bDuctSupplyTemperature',
        ACC_BDUCTSUPPLYTEMPERATURE_CONTROLTYPE_VISIBLE: 'Acc_bDuctSupplyTemperature.CONTROLTYPE.VISIBLE',
        ACC_BEDGEPROBYPASSDAMPER: 'Acc_bEdgeProBypassDamper',
        ACC_BEDGEPROHUMIDIMIZER: 'Acc_bEdgeProHumidiMiZer',
        ACC_BHORNORSTROBEANNUNCIATOR: 'Acc_bHornOrStrobeAnnunciator',
        ACC_BHORNORSTROBEANNUNCIATOR_CONTROLTYPE_VISIBLE: 'Acc_bHornOrStrobeAnnunciator.CONTROLTYPE.VISIBLE',
        ACC_BLOUVEREDHAILGUARD: 'Acc_bLouveredHailGuard',
        ACC_BLOWSOUNDINDIVIDUALCOMPRESSOR: 'Acc_bLowSoundIndividualCompressor',
        ACC_BLOWSOUNDINDIVIDUALCOMPRESSOR_CONTROLTYPE_VISIBLE: 'Acc_bLowSoundIndividualCompressor.CONTROLTYPE.VISIBLE',
        ACC_BPLUGGEDFILTER: 'Acc_bPluggedFilter',
        ACC_BPOWEREXHAUSTHICAP1: 'Acc_bPowerExhaustHiCap1',
        ACC_BPOWEREXHAUSTHICAP2: 'Acc_bPowerExhaustHiCap2',
        ACC_BPOWEREXHAUSTHICAP3: 'Acc_bPowerExhaustHiCap3',
        ACC_BPOWEREXHAUSTMULTISTAGE: 'Acc_bPowerExhaustMultiStage',
        ACC_BRETURNAIRSMOKEDETECTOR: 'Acc_bReturnAirSmokeDetector',
        ACC_BRHSPACESENSOR: 'Acc_bRHSpaceSensor',
        ACC_BRHSPACESENSOR_CONTROLTYPE_VISIBLE: 'Acc_bRHSpaceSensor.CONTROLTYPE.VISIBLE',
        ACC_BROOFCURBS: 'Acc_bRoofCurbs',
        ACC_BSMOKEDETECTOR: 'Acc_bSmokeDetector',
        ACC_BSMOKEDETECTOR_CONTROLTYPE_VISIBLE: 'Acc_bSmokeDetector.CONTROLTYPE.VISIBLE',
        ACC_BSMOKEDETECTORREMOTE: 'Acc_bSmokeDetectorRemote',
        ACC_BSMOKEDETECTORREMOTE_CONTROLTYPE_VISIBLE: 'Acc_bSmokeDetectorRemote.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPC02ROOMSENSOR: 'Acc_bSpaceTempC02RoomSensor',
        ACC_BSPACETEMPC02ROOMSENSOR_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempC02RoomSensor.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPC02ROOMSENSORSETPOINT: 'Acc_bSpaceTempC02RoomSensorSetPoint',
        ACC_BSPACETEMPLCDDISPLAY: 'Acc_bSpaceTempLCDDisplay',
        ACC_BSPACETEMPLCDDISPLAY_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempLCDDisplay.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPOVERRIDEBUTTON: 'Acc_bSpaceTempOverrideButton',
        ACC_BSPACETEMPOVERRIDEBUTTON_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempOverrideButton.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPSLIDEBAR: 'Acc_bSpaceTempSlideBar',
        ACC_BSPACETEMPSLIDEBAR_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempSlideBar.CONTROLTYPE.VISIBLE',
        ACC_BSUPPLYSMOKEDETECTOR: 'Acc_bSupplySmokeDetector',
        ACC_BSUPPLYSMOKEDETECTOR_CONTROLTYPE_VISIBLE: 'Acc_bSupplySmokeDetector.CONTROLTYPE.VISIBLE',
        ACC_BTOUCHNGO2STAGE: 'Acc_bTouchNGo2Stage',
        ACC_BUVCBULBKIT: 'Acc_bUVCBulbKit',
        ACC_BVFDDISPLAYKIT: 'Acc_bVFDDisplayKit',
        ACC_BVFDDISPLAYKIT_CONTROLTYPE_VISIBLE: 'Acc_bVFDDisplayKit.CONTROLTYPE.VISIBLE',
        ACC_SCATEGORY: 'Acc_sCategory',
        ACO_BSPECIFYBARRIER: 'ACO_bSpecifyBarrier',
        ACO_BSPECIFYREFLECTION: 'ACO_bSpecifyReflection',
        ACO_FHEIGHTBARRIER: 'ACO_fHeightBarrier',
        ACO_FHEIGHTBARRIER_DISPLAYUNIT: 'ACO_fHeightBarrier.DISPLAYUNIT',
        ACO_FHEIGHTBARRIER_UNIT: 'ACO_fHeightBarrier.UNIT',
        ACO_FHEIGHTRECEIVER: 'ACO_fHeightReceiver',
        ACO_FHEIGHTRECEIVER_DISPLAYUNIT: 'ACO_fHeightReceiver.DISPLAYUNIT',
        ACO_FHEIGHTRECEIVER_UNIT: 'ACO_fHeightReceiver.UNIT',
        ACO_FHEIGHTSOURCE: 'ACO_fHeightSource',
        ACO_FHEIGHTSOURCE_DISPLAYUNIT: 'ACO_fHeightSource.DISPLAYUNIT',
        ACO_FHEIGHTSOURCE_UNIT: 'ACO_fHeightSource.UNIT',
        ACO_FHORZDISTANCERECEIVER: 'ACO_fHorzDistanceReceiver',
        ACO_FHORZDISTANCERECEIVER_DISPLAYUNIT: 'ACO_fHorzDistanceReceiver.DISPLAYUNIT',
        ACO_FHORZDISTANCERECEIVER_UNIT: 'ACO_fHorzDistanceReceiver.UNIT',
        ACO_FHORZDISTANCERECEIVERBARR: 'ACO_fHorzDistanceReceiverBarr',
        ACO_FHORZDISTANCERECEIVERBARR_DISPLAYUNIT: 'ACO_fHorzDistanceReceiverBarr.DISPLAYUNIT',
        ACO_FHORZDISTANCERECEIVERBARR_UNIT: 'ACO_fHorzDistanceReceiverBarr.UNIT',
        ACO_FHORZDISTANCEUNITBARR: 'ACO_fHorzDistanceUnitBarr',
        ACO_FHORZDISTANCEUNITBARR_DISPLAYUNIT: 'ACO_fHorzDistanceUnitBarr.DISPLAYUNIT',
        ACO_FHORZDISTANCEUNITBARR_UNIT: 'ACO_fHorzDistanceUnitBarr.UNIT',
        ACO_SCATEGORY: 'ACO_sCategory',
        BU_SAPPLICATIONTYPE: 'BU_sApplicationType',
        BU_SHEATCAPACITY: 'BU_sHeatCapacity',
        DC_BCHECKHUMIDIMIZERFORM: 'DC_bCheckHumidimizerForm',
        DC_BCHECKMAXCOOLING: 'DC_bCheckMaxCooling',
        DC_BCHECKMAXDEHUMIDIFICATION: 'DC_bCheckMaxDeHumidification',
        DC_BCHECKPARTLOADHUMIDIFICATION: 'DC_bCheckPartLoadHumidification',
        DC_FMAXDEHUMCONDENSERENTTEMP: 'DC_fMaxDeHumCondenserEntTemp',
        DC_FMAXDEHUMCONDENSERENTTEMP_DISPLAYUNIT: 'DC_fMaxDeHumCondenserEntTemp.DISPLAYUNIT',
        DC_FMAXDEHUMCONDENSERENTTEMP_UNIT: 'DC_fMaxDeHumCondenserEntTemp.UNIT',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB: 'DC_fMaxDeHumEvapEntTempDryBulb',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB_DISPLAYUNIT: 'DC_fMaxDeHumEvapEntTempDryBulb.DISPLAYUNIT',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB_UNIT: 'DC_fMaxDeHumEvapEntTempDryBulb.UNIT',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB: 'DC_fMaxDeHumEvapEntTempWetBulb',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB_DISPLAYUNIT: 'DC_fMaxDeHumEvapEntTempWetBulb.DISPLAYUNIT',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB_UNIT: 'DC_fMaxDeHumEvapEntTempWetBulb.UNIT',
        DC_FPLCONDENSERENTTEMP: 'DC_fPLCondenserEntTemp',
        DC_FPLCONDENSERENTTEMP_DISPLAYUNIT: 'DC_fPLCondenserEntTemp.DISPLAYUNIT',
        DC_FPLCONDENSERENTTEMP_UNIT: 'DC_fPLCondenserEntTemp.UNIT',
        DC_FPLEVAPENTTEMPDRYBULB: 'DC_fPLEvapEntTempDryBulb',
        DC_FPLEVAPENTTEMPDRYBULB_DISPLAYUNIT: 'DC_fPLEvapEntTempDryBulb.DISPLAYUNIT',
        DC_FPLEVAPENTTEMPDRYBULB_UNIT: 'DC_fPLEvapEntTempDryBulb.UNIT',
        DC_FPLEVAPENTTEMPWETBULB: 'DC_fPLEvapEntTempWetBulb',
        DC_FPLEVAPENTTEMPWETBULB_DISPLAYUNIT: 'DC_fPLEvapEntTempWetBulb.DISPLAYUNIT',
        DC_FPLEVAPENTTEMPWETBULB_UNIT: 'DC_fPLEvapEntTempWetBulb.UNIT',
        DC_FPWREXTERNALSTATIC: 'DC_fPwrExternalStatic',
        DC_FPWREXTERNALSTATIC_DISPLAYUNIT: 'DC_fPwrExternalStatic.DISPLAYUNIT',
        DC_FPWREXTERNALSTATIC_UNIT: 'DC_fPwrExternalStatic.UNIT',
        OPT_BAUTOSELECTSUPPLYFANMOTORSIZE: 'OPT_bAutoSelectSupplyFanMotorSize',
        OPT_BBOTTOMCONSTRUCTION: 'OPT_bBottomConstruction',
        OPT_BCONDENSEOVERFLOWSWITCH: 'OPT_bCondenseOverflowSwitch',
        OPT_BDIGITALCOMPRESSOR: 'Opt_bDigitalCompressor',
        OPT_BDRAINPANTYPES: 'OPT_bDrainPanTypes',
        OPT_BHAILGUARD: 'OPT_bHailGuard',
        OPT_BHUMIDIMIZER: 'OPT_bHumidimizer',
        OPT_BHUMIDIMIZER_CHILDREN: 'OPT_bHumidimizer.CHILDREN',
        OPT_BHUMIDITYSENSORS: 'OPT_bHumiditySensors',
        OPT_BIAQOPTIONS: 'OPT_bIAQOptions',
        OPT_BLOWAMBIENT: 'OPT_bLowAmbient',
        OPT_BLOWSOUNDCNDFANS: 'OPT_bLowSoundCndFans',
        OPT_BMOTORPROTECTION: 'Opt_bMotorProtection',
        OPT_BNONFUSEDDISCONNECT: 'OPT_bNonFusedDisconnect',
        OPT_BPHASEMONITOR: 'OPT_bPhaseMonitor',
        OPT_BREFRIGERANTRELIEFVALUE: 'OPT_bRefrigerantReliefValue',
        OPT_BRETURNAIRCO2SENSOR: 'OPT_bReturnAirCO2Sensor',
        OPT_BRETURNAIRSMOKEDETECTOR: 'OPT_bReturnAirSmokeDetector',
        OPT_BSERVICEPACK: 'OPT_bServicePack',
        OPT_BSUPPLYFANMOTOR: 'Opt_bSupplyFanMotor',
        OPT_BTERMINALBLOCK: 'OPT_bTerminalBlock',
        OPT_BVFDBYPASS: 'Opt_bVfdBypass',
        OPT_NONFUSEDDISCONNECT_NOTE: 'OPT_Nonfuseddisconnect_Note',
        OPT_SCATEGORY: 'Opt_sCategory',
        OPT_SCOILFINCOATING: 'Opt_sCoilFinCoating',
        OPT_SCONSTRUCTION: 'OPT_sConstruction',
        OPT_SCONVENIENCEOUTLET: 'Opt_sConvenienceOutlet',
        OPT_SHEATOPTION: 'OPT_sHeatOption',
        OPT_SOUTDOORAIR: 'Opt_sOutdoorAir',
        OPT_SPREFILTERMSTYPES: 'OPT_sPreFilterMSTypes',
        OPT_SPREFILTERTYPES: 'OPT_sPreFilterTypes',
        OPT_SRELIEFTYPE: 'OPT_sReliefType',
        OPT_SRELIEFTYPE_CHILDREN: 'OPT_sReliefType.CHILDREN',
        OPT_SSCCR: 'OPT_sSCCR',
        OPT_SSCCR_NOTE: 'OPT_sSCCR_Note',
        OPT_SSUPPLYFANMOTORSIZE: 'Opt_sSupplyFanMotorSize',
        OPT_SSUPPLYFANMOTORSIZE_CHILDREN: 'Opt_sSupplyFanMotorSize.CHILDREN',
        OPT_SUNITEFFICIENCY: 'Opt_sUnitEfficiency',
        PC_IN_BHASLOWLOADMCHXRESTRICTION: 'PC_In_bHasLowLoadMCHXRestriction',
        PC_IN_BLOCALCORROSIVEENV: 'PC_In_bLocalCorrosiveEnv',
        PC_IN_SCOUNTRYCODE: 'PC_In_sCountryCode',
        PC_IN_SPOSTALCODE: 'PC_In_sPostalCode',
        PC_OUT_BCOILCOATINGREQUIRED: 'PC_Out_bCoilCoatingRequired',
        PC_OUT_BPOSTALCODEVALIDITY: 'PC_Out_bPostalCodeValidity',
        STARTUP_BADDITIONALUNITCOOLING: 'StartUp_bAdditionalUnitCooling',
        STARTUP_BADDITIONALUNITHEATING: 'StartUp_bAdditionalUnitHeating',
        STARTUP_BFIRSTUNITCOOLING: 'StartUp_bFirstUnitCooling',
        STARTUP_BFIRSTUNITHEATING: 'StartUp_bFirstUnitHeating',
        STARTUP_SCATEGORY: 'StartUp_sCategory',
        WAR_B1STYEARCARRIERCCSLABOR: 'War_b1stYearCarrierCCSLabor',
        WAR_BCOMPLETE2YEARPARTSANDLABOR: 'War_bComplete2YearPartsAndLabor',
        WAR_BCOMPLETE2YEARPARTSONLY: 'War_bComplete2YearPartsOnly',
        WAR_BCOMPLETE3YEARPARTSANDLABOR: 'War_bComplete3YearPartsAndLabor',
        WAR_BCOMPLETE3YEARPARTSONLY: 'War_bComplete3YearPartsOnly',
        WAR_BCOMPLETE4YEARPARTSANDLABOR: 'War_bComplete4YearPartsAndLabor',
        WAR_BCOMPLETE4YEARPARTSONLY: 'War_bComplete4YearPartsOnly',
        WAR_BCOMPLETE5YEARPARTSANDLABOR: 'War_bComplete5YearPartsAndLabor',
        WAR_BCOMPLETE5YEARPARTSONLY: 'War_bComplete5YearPartsOnly',
        WAR_BCOMPRESSOR2YEARPARTSANDLABOR: 'War_bCompressor2YearPartsAndLabor',
        WAR_BCOMPRESSOR2YEARPARTSONLY: 'War_bCompressor2YearPartsOnly',
        WAR_BCOMPRESSOR3YEARPARTSANDLABOR: 'War_bCompressor3YearPartsAndLabor',
        WAR_BCOMPRESSOR3YEARPARTSONLY: 'War_bCompressor3YearPartsOnly',
        WAR_BCOMPRESSOR4YEARPARTSANDLABOR: 'War_bCompressor4YearPartsAndLabor',
        WAR_BCOMPRESSOR4YEARPARTSONLY: 'War_bCompressor4YearPartsOnly',
        WAR_BCOMPRESSOR5YEARPARTSANDLABOR: 'War_bCompressor5YearPartsAndLabor',
        WAR_BCOMPRESSOR5YEARPARTSONLY: 'War_bCompressor5YearPartsOnly',
        WAR_SCATEGORY: 'War_sCategory',
        ACC_BFLUEKITEXTENSIONKIT: 'Acc_bFlueKitExtensionKit',
        ACC_BLPCONVERSIONKIT: 'Acc_bLPConversionKit',
        OPT_BSTAINLESSSTEEL_EXCHANGER: 'OPT_bStainlessSteel_Exchanger',
        WAR_BALGASHEATEXCHANGERPARTSONLY: 'War_bALGasHeatExchangerPartsOnly',
        WAR_BSSGASHEATEXCHANGERPARTSONLY: 'War_bSSGasHeatExchangerPartsOnly',
        ACC_B12INCHMERV14SYNTHETICCARTRIDGEFILTERKIT: 'Acc_b12InchMERV14SyntheticCartridgeFilterKit',
        ACC_B2INCHMERV8FILTERBAGCARTR: 'Acc_b2InchMERV8FilterBagCartr',
        ACC_BFILTERHOOK: 'Acc_bFilterHook',
        ACC_BFILTERHOOK_CONTROLTYPE_VISIBLE: 'Acc_bFilterHook.CONTROLTYPE.VISIBLE',
        ACC_BHUMIDISTAT: 'Acc_bHumidistat',
        ACC_BLPCONVERSIONANDHIGHELEVATIONKIT: 'Acc_bLPConversionandHighElevationKit',
        ACC_BLPCONVERSIONANDHIGHELEVATIONKIT_CONTROLTYPE_VISIBLE: 'Acc_bLPConversionandHighElevationKit.CONTROLTYPE.VISIBLE',
        ACC_BNGHIGHELEVATIONKIT: 'Acc_bNGHighElevationKit',
        ACC_BNGHIGHELEVATIONKIT_CONTROLTYPE_VISIBLE: 'Acc_bNGHighElevationKit.CONTROLTYPE.VISIBLE',
        ACC_BROOFCURBCONVERSIONKIT: 'Acc_bRoofCurbConversionKit',
        ACC_BSUPPLYANDRETURNTOOLSCREEN: 'Acc_bSupplyandReturnToolScreen',
        ACC_BSUPPLYANDRETURNTOOLSCREEN_CONTROLTYPE_VISIBLE: 'Acc_bSupplyandReturnToolScreen.CONTROLTYPE.VISIBLE',
        ACC_BUVCEMITTERKIT: 'Acc_bUVCEmitterKit',
        ACC_BUVCEMITTERKIT_CONTROLTYPE_VISIBLE: 'Acc_bUVCEmitterKit.CONTROLTYPE.VISIBLE',
        OPT_BBAROMETRICRELIEF: 'OPT_bBarometricRelief',
        OPT_BEXTENDEDSECTION: 'OPT_bExtendedSection',
        OPT_BLOWSTATICEXHAUSTFAN: 'OPT_bLowStaticExhaustFan',
        OPT_BLOWSTATICEXHAUSTFAN_CHILDREN: 'OPT_bLowStaticExhaustFan.CHILDREN',
        OPT_BLOWSTATICEXHAUSTFAN_CONTROLTYPE_VALID: 'OPT_bLowStaticExhaustFan.CONTROLTYPE.VALID',
        OPT_BMEDSTATICEXHAUSTFAN: 'OPT_bMedStaticExhaustFan',
        OPT_BMEDSTATICEXHAUSTFAN_CHILDREN: 'OPT_bMedStaticExhaustFan.CHILDREN',
        OPT_BMODULATINGBPCONTROL: 'OPT_bModulatingBPControl',
        OPT_BOUTDOORAIRFLOW: 'OPT_bOutdoorAirflow',
        OPT_BSTDSTATICEXHAUSTFAN: 'OPT_bStdStaticExhaustFan',
        OPT_BSTDSTATICEXHAUSTFAN_CHILDREN: 'OPT_bStdStaticExhaustFan.CHILDREN',
        OPT_SCHASSIS: 'Opt_sChassis',
        OPT_SCOMPRESSOR: 'OPT_sCompressor',
        OPT_SMOTORSTATIC: 'OPT_sMotorStatic',
        OPT_SMOTORSTATIC_CHILDREN: 'OPT_sMotorStatic.CHILDREN',
        OPT_BPLENUMSECTION: 'OPT_bPlenumSection',
    },
    [TAGS.UI_CONFIG_UNIT_ACC]: {
        ACC_B20AMPNONPOWERED: 'Acc_b20AmpNonPowered',
        ACC_B20AMPNONPOWERED_CONTROLTYPE_VISIBLE: 'Acc_b20AmpNonPowered.CONTROLTYPE.VISIBLE',
        ACC_B2INCHMERV8FILTERKIT: 'Acc_b2InchMERV8FilterKit',
        ACC_B4INCHCOMMERCIALTHERMOSTAT: 'Acc_b4InchCommercialThermostat',
        ACC_B4INCHCOMMERCIALTHERMOSTAT_CONTROLTYPE_VISIBLE: 'Acc_b4InchCommercialThermostat.CONTROLTYPE.VISIBLE',
        ACC_B4INCHMERV13FILTERKIT: 'Acc_b4InchMERV13FilterKit',
        ACC_B4INCHMERV8CARBONFILTERKIT: 'Acc_b4InchMERV8CarbonFilterKit',
        ACC_B4INCHMERV8FILTERKIT: 'Acc_b4InchMERV8FilterKit',
        ACC_BASPIRATORBOX: 'Acc_bAspiratorBox',
        ACC_BASPIRATORBOX_CONTROLTYPE_VISIBLE: 'Acc_bAspiratorBox.CONTROLTYPE.VISIBLE',
        ACC_BBAROMETRICRELIEF: 'Acc_bBarometricRelief',
        ACC_BC02SPACETEMPNOLCD: 'Acc_bC02SpaceTempNoLCD',
        ACC_BC02SPACETEMPNOLCD_CONTROLTYPE_VISIBLE: 'Acc_bC02SpaceTempNoLCD.CONTROLTYPE.VISIBLE',
        ACC_BCARRIERTRANSLATORLOMWORKS: 'Acc_bCarrierTranslatorLomWorks',
        ACC_BCARRIERTRANSLATORLOMWORKS_CONTROLTYPE_VISIBLE: 'Acc_bCarrierTranslatorLomWorks.CONTROLTYPE.VISIBLE',
        ACC_BCARRIERTRANSLATORMODBUS: 'Acc_bCarrierTranslatorModbus',
        ACC_BCARRIERTRANSLATORMODBUS_CONTROLTYPE_VISIBLE: 'Acc_bCarrierTranslatorModbus.CONTROLTYPE.VISIBLE',
        ACC_BCOMFORT2STAGE: 'Acc_bComfort2Stage',
        ACC_BCOMFORT2STAGE_CONTROLTYPE_VISIBLE: 'Acc_bComfort2Stage.CONTROLTYPE.VISIBLE',
        ACC_BCOMMERCIALTHERMOSTAT: 'Acc_bCommercialThermostat',
        ACC_BCOMMERCIALTHERMOSTAT_CONTROLTYPE_VISIBLE: 'Acc_bCommercialThermostat.CONTROLTYPE.VISIBLE',
        ACC_BCOMPRESSORSOUNDBLANKET: 'Acc_bCompressorSoundBlanket',
        ACC_BDUCTSUPPLYTEMPERATURE: 'Acc_bDuctSupplyTemperature',
        ACC_BDUCTSUPPLYTEMPERATURE_CONTROLTYPE_VISIBLE: 'Acc_bDuctSupplyTemperature.CONTROLTYPE.VISIBLE',
        ACC_BEDGEPROBYPASSDAMPER: 'Acc_bEdgeProBypassDamper',
        ACC_BEDGEPROHUMIDIMIZER: 'Acc_bEdgeProHumidiMiZer',
        ACC_BHORNORSTROBEANNUNCIATOR: 'Acc_bHornOrStrobeAnnunciator',
        ACC_BHORNORSTROBEANNUNCIATOR_CONTROLTYPE_VISIBLE: 'Acc_bHornOrStrobeAnnunciator.CONTROLTYPE.VISIBLE',
        ACC_BLOUVEREDHAILGUARD: 'Acc_bLouveredHailGuard',
        ACC_BLOWSOUNDINDIVIDUALCOMPRESSOR: 'Acc_bLowSoundIndividualCompressor',
        ACC_BLOWSOUNDINDIVIDUALCOMPRESSOR_CONTROLTYPE_VISIBLE: 'Acc_bLowSoundIndividualCompressor.CONTROLTYPE.VISIBLE',
        ACC_BPLUGGEDFILTER: 'Acc_bPluggedFilter',
        ACC_BPOWEREXHAUSTHICAP1: 'Acc_bPowerExhaustHiCap1',
        ACC_BPOWEREXHAUSTHICAP2: 'Acc_bPowerExhaustHiCap2',
        ACC_BPOWEREXHAUSTHICAP3: 'Acc_bPowerExhaustHiCap3',
        ACC_BPOWEREXHAUSTMULTISTAGE: 'Acc_bPowerExhaustMultiStage',
        ACC_BRETURNAIRSMOKEDETECTOR: 'Acc_bReturnAirSmokeDetector',
        ACC_BRHSPACESENSOR: 'Acc_bRHSpaceSensor',
        ACC_BRHSPACESENSOR_CONTROLTYPE_VISIBLE: 'Acc_bRHSpaceSensor.CONTROLTYPE.VISIBLE',
        ACC_BROOFCURBS: 'Acc_bRoofCurbs',
        ACC_BSMOKEDETECTOR: 'Acc_bSmokeDetector',
        ACC_BSMOKEDETECTOR_CONTROLTYPE_VISIBLE: 'Acc_bSmokeDetector.CONTROLTYPE.VISIBLE',
        ACC_BSMOKEDETECTORREMOTE: 'Acc_bSmokeDetectorRemote',
        ACC_BSMOKEDETECTORREMOTE_CONTROLTYPE_VISIBLE: 'Acc_bSmokeDetectorRemote.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPC02ROOMSENSOR: 'Acc_bSpaceTempC02RoomSensor',
        ACC_BSPACETEMPC02ROOMSENSOR_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempC02RoomSensor.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPC02ROOMSENSORSETPOINT: 'Acc_bSpaceTempC02RoomSensorSetPoint',
        ACC_BSPACETEMPLCDDISPLAY: 'Acc_bSpaceTempLCDDisplay',
        ACC_BSPACETEMPLCDDISPLAY_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempLCDDisplay.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPOVERRIDEBUTTON: 'Acc_bSpaceTempOverrideButton',
        ACC_BSPACETEMPOVERRIDEBUTTON_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempOverrideButton.CONTROLTYPE.VISIBLE',
        ACC_BSPACETEMPSLIDEBAR: 'Acc_bSpaceTempSlideBar',
        ACC_BSPACETEMPSLIDEBAR_CONTROLTYPE_VISIBLE: 'Acc_bSpaceTempSlideBar.CONTROLTYPE.VISIBLE',
        ACC_BSUPPLYSMOKEDETECTOR: 'Acc_bSupplySmokeDetector',
        ACC_BSUPPLYSMOKEDETECTOR_CONTROLTYPE_VISIBLE: 'Acc_bSupplySmokeDetector.CONTROLTYPE.VISIBLE',
        ACC_BTOUCHNGO2STAGE: 'Acc_bTouchNGo2Stage',
        ACC_BUVCBULBKIT: 'Acc_bUVCBulbKit',
        ACC_BVFDDISPLAYKIT: 'Acc_bVFDDisplayKit',
        ACC_BVFDDISPLAYKIT_CONTROLTYPE_VISIBLE: 'Acc_bVFDDisplayKit.CONTROLTYPE.VISIBLE',
        ACC_SCATEGORY: 'Acc_sCategory',
        WAR_SCATEGORY: 'War_sCategory',
        ACC_BFLUEKITEXTENSIONKIT: 'Acc_bFlueKitExtensionKit',
        ACC_BLPCONVERSIONKIT: 'Acc_bLPConversionKit',
        ACC_B12INCHMERV14SYNTHETICCARTRIDGEFILTERKIT: 'Acc_b12InchMERV14SyntheticCartridgeFilterKit',
        ACC_B2INCHMERV8FILTERBAGCARTR: 'Acc_b2InchMERV8FilterBagCartr',
        ACC_BFILTERHOOK: 'Acc_bFilterHook',
        ACC_BFILTERHOOK_CONTROLTYPE_VISIBLE: 'Acc_bFilterHook.CONTROLTYPE.VISIBLE',
        ACC_BHUMIDISTAT: 'Acc_bHumidistat',
        ACC_BLPCONVERSIONANDHIGHELEVATIONKIT: 'Acc_bLPConversionandHighElevationKit',
        ACC_BLPCONVERSIONANDHIGHELEVATIONKIT_CONTROLTYPE_VISIBLE: 'Acc_bLPConversionandHighElevationKit.CONTROLTYPE.VISIBLE',
        ACC_BNGHIGHELEVATIONKIT: 'Acc_bNGHighElevationKit',
        ACC_BNGHIGHELEVATIONKIT_CONTROLTYPE_VISIBLE: 'Acc_bNGHighElevationKit.CONTROLTYPE.VISIBLE',
        ACC_BROOFCURBCONVERSIONKIT: 'Acc_bRoofCurbConversionKit',
        ACC_BSUPPLYANDRETURNTOOLSCREEN: 'Acc_bSupplyandReturnToolScreen',
        ACC_BSUPPLYANDRETURNTOOLSCREEN_CONTROLTYPE_VISIBLE: 'Acc_bSupplyandReturnToolScreen.CONTROLTYPE.VISIBLE',
        ACC_BUVCEMITTERKIT: 'Acc_bUVCEmitterKit',
        ACC_BUVCEMITTERKIT_CONTROLTYPE_VISIBLE: 'Acc_bUVCEmitterKit.CONTROLTYPE.VISIBLE',
    },
    [TAGS.ACC_CAT_FILTERS]: {
        ACC_B2INCHMERV8FILTERKIT: 'Acc_b2InchMERV8FilterKit',
        ACC_B4INCHMERV13FILTERKIT: 'Acc_b4InchMERV13FilterKit',
        ACC_B4INCHMERV8CARBONFILTERKIT: 'Acc_b4InchMERV8CarbonFilterKit',
        ACC_B4INCHMERV8FILTERKIT: 'Acc_b4InchMERV8FilterKit',
        ACC_B12INCHMERV14SYNTHETICCARTRIDGEFILTERKIT: 'Acc_b12InchMERV14SyntheticCartridgeFilterKit',
        ACC_B2INCHMERV8FILTERBAGCARTR: 'Acc_b2InchMERV8FilterBagCartr',
        ACC_BLPCONVERSIONANDHIGHELEVATIONKIT: 'Acc_bLPConversionandHighElevationKit',
        ACC_BLPCONVERSIONANDHIGHELEVATIONKIT_CONTROLTYPE_VISIBLE: 'Acc_bLPConversionandHighElevationKit.CONTROLTYPE.VISIBLE',
        ACC_BNGHIGHELEVATIONKIT: 'Acc_bNGHighElevationKit',
        ACC_BNGHIGHELEVATIONKIT_CONTROLTYPE_VISIBLE: 'Acc_bNGHighElevationKit.CONTROLTYPE.VISIBLE',
        ACC_BUVCEMITTERKIT: 'Acc_bUVCEmitterKit',
        ACC_BUVCEMITTERKIT_CONTROLTYPE_VISIBLE: 'Acc_bUVCEmitterKit.CONTROLTYPE.VISIBLE',
    },
    [TAGS.ACC_CAT_THERMOSTAT]: {
        ACC_B4INCHCOMMERCIALTHERMOSTAT: 'Acc_b4InchCommercialThermostat',
        ACC_B4INCHCOMMERCIALTHERMOSTAT_CONTROLTYPE_VISIBLE: 'Acc_b4InchCommercialThermostat.CONTROLTYPE.VISIBLE',
        ACC_BCOMFORT2STAGE: 'Acc_bComfort2Stage',
        ACC_BCOMFORT2STAGE_CONTROLTYPE_VISIBLE: 'Acc_bComfort2Stage.CONTROLTYPE.VISIBLE',
        ACC_BCOMMERCIALTHERMOSTAT: 'Acc_bCommercialThermostat',
        ACC_BCOMMERCIALTHERMOSTAT_CONTROLTYPE_VISIBLE: 'Acc_bCommercialThermostat.CONTROLTYPE.VISIBLE',
        ACC_BEDGEPROBYPASSDAMPER: 'Acc_bEdgeProBypassDamper',
        ACC_BEDGEPROHUMIDIMIZER: 'Acc_bEdgeProHumidiMiZer',
        ACC_BTOUCHNGO2STAGE: 'Acc_bTouchNGo2Stage',
        ACC_BHUMIDISTAT: 'Acc_bHumidistat',
    },
    [TAGS.ACC_CAT_OUTSIDEAIR]: {
        ACC_BBAROMETRICRELIEF: 'Acc_bBarometricRelief',
    },
    [TAGS.ACC_CAT_COMPSOUNDBLNK]: {
        ACC_BCOMPRESSORSOUNDBLANKET: 'Acc_bCompressorSoundBlanket',
    },
    [TAGS.ACC_CAT_HAILGUARD]: {
        ACC_BLOUVEREDHAILGUARD: 'Acc_bLouveredHailGuard',
    },
    [TAGS.ACC_CAT_POWEREXH]: {
        ACC_BPOWEREXHAUSTHICAP1: 'Acc_bPowerExhaustHiCap1',
        ACC_BPOWEREXHAUSTHICAP2: 'Acc_bPowerExhaustHiCap2',
        ACC_BPOWEREXHAUSTHICAP3: 'Acc_bPowerExhaustHiCap3',
        ACC_BPOWEREXHAUSTMULTISTAGE: 'Acc_bPowerExhaustMultiStage',
    },
    [TAGS.ACC_CAT_ROOFCURB]: {
        ACC_BROOFCURBS: 'Acc_bRoofCurbs',
        ACC_BROOFCURBCONVERSIONKIT: 'Acc_bRoofCurbConversionKit',
    },
    [TAGS.ACC_CAT_UVCBULBKIT]: {
        ACC_BUVCBULBKIT: 'Acc_bUVCBulbKit',
    },
    [TAGS.UI_CONFIG_UNIT_ACO]: {
        ACO_BSPECIFYBARRIER: 'ACO_bSpecifyBarrier',
        ACO_BSPECIFYREFLECTION: 'ACO_bSpecifyReflection',
        ACO_FHEIGHTBARRIER: 'ACO_fHeightBarrier',
        ACO_FHEIGHTBARRIER_DISPLAYUNIT: 'ACO_fHeightBarrier.DISPLAYUNIT',
        ACO_FHEIGHTBARRIER_UNIT: 'ACO_fHeightBarrier.UNIT',
        ACO_FHEIGHTRECEIVER: 'ACO_fHeightReceiver',
        ACO_FHEIGHTRECEIVER_DISPLAYUNIT: 'ACO_fHeightReceiver.DISPLAYUNIT',
        ACO_FHEIGHTRECEIVER_UNIT: 'ACO_fHeightReceiver.UNIT',
        ACO_FHEIGHTSOURCE: 'ACO_fHeightSource',
        ACO_FHEIGHTSOURCE_DISPLAYUNIT: 'ACO_fHeightSource.DISPLAYUNIT',
        ACO_FHEIGHTSOURCE_UNIT: 'ACO_fHeightSource.UNIT',
        ACO_FHORZDISTANCERECEIVER: 'ACO_fHorzDistanceReceiver',
        ACO_FHORZDISTANCERECEIVER_DISPLAYUNIT: 'ACO_fHorzDistanceReceiver.DISPLAYUNIT',
        ACO_FHORZDISTANCERECEIVER_UNIT: 'ACO_fHorzDistanceReceiver.UNIT',
        ACO_FHORZDISTANCERECEIVERBARR: 'ACO_fHorzDistanceReceiverBarr',
        ACO_FHORZDISTANCERECEIVERBARR_DISPLAYUNIT: 'ACO_fHorzDistanceReceiverBarr.DISPLAYUNIT',
        ACO_FHORZDISTANCERECEIVERBARR_UNIT: 'ACO_fHorzDistanceReceiverBarr.UNIT',
        ACO_FHORZDISTANCEUNITBARR: 'ACO_fHorzDistanceUnitBarr',
        ACO_FHORZDISTANCEUNITBARR_DISPLAYUNIT: 'ACO_fHorzDistanceUnitBarr.DISPLAYUNIT',
        ACO_FHORZDISTANCEUNITBARR_UNIT: 'ACO_fHorzDistanceUnitBarr.UNIT',
        ACO_SCATEGORY: 'ACO_sCategory',
    },
    [TAGS.UI_CONFIG_UNIT_OPT]: {
        BU_SAPPLICATIONTYPE: 'BU_sApplicationType',
        BU_SHEATCAPACITY: 'BU_sHeatCapacity',
        DC_BCHECKHUMIDIMIZERFORM: 'DC_bCheckHumidimizerForm',
        DC_BCHECKMAXCOOLING: 'DC_bCheckMaxCooling',
        DC_BCHECKMAXDEHUMIDIFICATION: 'DC_bCheckMaxDeHumidification',
        DC_BCHECKPARTLOADHUMIDIFICATION: 'DC_bCheckPartLoadHumidification',
        DC_FMAXDEHUMCONDENSERENTTEMP: 'DC_fMaxDeHumCondenserEntTemp',
        DC_FMAXDEHUMCONDENSERENTTEMP_DISPLAYUNIT: 'DC_fMaxDeHumCondenserEntTemp.DISPLAYUNIT',
        DC_FMAXDEHUMCONDENSERENTTEMP_UNIT: 'DC_fMaxDeHumCondenserEntTemp.UNIT',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB: 'DC_fMaxDeHumEvapEntTempDryBulb',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB_DISPLAYUNIT: 'DC_fMaxDeHumEvapEntTempDryBulb.DISPLAYUNIT',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB_UNIT: 'DC_fMaxDeHumEvapEntTempDryBulb.UNIT',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB: 'DC_fMaxDeHumEvapEntTempWetBulb',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB_DISPLAYUNIT: 'DC_fMaxDeHumEvapEntTempWetBulb.DISPLAYUNIT',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB_UNIT: 'DC_fMaxDeHumEvapEntTempWetBulb.UNIT',
        DC_FPLCONDENSERENTTEMP: 'DC_fPLCondenserEntTemp',
        DC_FPLCONDENSERENTTEMP_DISPLAYUNIT: 'DC_fPLCondenserEntTemp.DISPLAYUNIT',
        DC_FPLCONDENSERENTTEMP_UNIT: 'DC_fPLCondenserEntTemp.UNIT',
        DC_FPLEVAPENTTEMPDRYBULB: 'DC_fPLEvapEntTempDryBulb',
        DC_FPLEVAPENTTEMPDRYBULB_DISPLAYUNIT: 'DC_fPLEvapEntTempDryBulb.DISPLAYUNIT',
        DC_FPLEVAPENTTEMPDRYBULB_UNIT: 'DC_fPLEvapEntTempDryBulb.UNIT',
        DC_FPLEVAPENTTEMPWETBULB: 'DC_fPLEvapEntTempWetBulb',
        DC_FPLEVAPENTTEMPWETBULB_DISPLAYUNIT: 'DC_fPLEvapEntTempWetBulb.DISPLAYUNIT',
        DC_FPLEVAPENTTEMPWETBULB_UNIT: 'DC_fPLEvapEntTempWetBulb.UNIT',
        DC_FPWREXTERNALSTATIC: 'DC_fPwrExternalStatic',
        DC_FPWREXTERNALSTATIC_DISPLAYUNIT: 'DC_fPwrExternalStatic.DISPLAYUNIT',
        DC_FPWREXTERNALSTATIC_UNIT: 'DC_fPwrExternalStatic.UNIT',
        OPT_BAUTOSELECTSUPPLYFANMOTORSIZE: 'OPT_bAutoSelectSupplyFanMotorSize',
        OPT_BBOTTOMCONSTRUCTION: 'OPT_bBottomConstruction',
        OPT_BCONDENSEOVERFLOWSWITCH: 'OPT_bCondenseOverflowSwitch',
        OPT_BDIGITALCOMPRESSOR: 'Opt_bDigitalCompressor',
        OPT_BDRAINPANTYPES: 'OPT_bDrainPanTypes',
        OPT_BHAILGUARD: 'OPT_bHailGuard',
        OPT_BHUMIDIMIZER: 'OPT_bHumidimizer',
        OPT_BHUMIDIMIZER_CHILDREN: 'OPT_bHumidimizer.CHILDREN',
        OPT_BHUMIDITYSENSORS: 'OPT_bHumiditySensors',
        OPT_BIAQOPTIONS: 'OPT_bIAQOptions',
        OPT_BLOWAMBIENT: 'OPT_bLowAmbient',
        OPT_BLOWSOUNDCNDFANS: 'OPT_bLowSoundCndFans',
        OPT_BMOTORPROTECTION: 'Opt_bMotorProtection',
        OPT_BNONFUSEDDISCONNECT: 'OPT_bNonFusedDisconnect',
        OPT_BPHASEMONITOR: 'OPT_bPhaseMonitor',
        OPT_BREFRIGERANTRELIEFVALUE: 'OPT_bRefrigerantReliefValue',
        OPT_BRETURNAIRCO2SENSOR: 'OPT_bReturnAirCO2Sensor',
        OPT_BRETURNAIRSMOKEDETECTOR: 'OPT_bReturnAirSmokeDetector',
        OPT_BSERVICEPACK: 'OPT_bServicePack',
        OPT_BSUPPLYFANMOTOR: 'Opt_bSupplyFanMotor',
        OPT_BTERMINALBLOCK: 'OPT_bTerminalBlock',
        OPT_BVFDBYPASS: 'Opt_bVfdBypass',
        OPT_NONFUSEDDISCONNECT_NOTE: 'OPT_Nonfuseddisconnect_Note',
        OPT_SCATEGORY: 'Opt_sCategory',
        OPT_SCOILFINCOATING: 'Opt_sCoilFinCoating',
        OPT_SCONSTRUCTION: 'OPT_sConstruction',
        OPT_SCONVENIENCEOUTLET: 'Opt_sConvenienceOutlet',
        OPT_SHEATOPTION: 'OPT_sHeatOption',
        OPT_SOUTDOORAIR: 'Opt_sOutdoorAir',
        OPT_SPREFILTERMSTYPES: 'OPT_sPreFilterMSTypes',
        OPT_SPREFILTERTYPES: 'OPT_sPreFilterTypes',
        OPT_SRELIEFTYPE: 'OPT_sReliefType',
        OPT_SRELIEFTYPE_CHILDREN: 'OPT_sReliefType.CHILDREN',
        OPT_SSCCR: 'OPT_sSCCR',
        OPT_SSCCR_NOTE: 'OPT_sSCCR_Note',
        OPT_SSUPPLYFANMOTORSIZE: 'Opt_sSupplyFanMotorSize',
        OPT_SSUPPLYFANMOTORSIZE_CHILDREN: 'Opt_sSupplyFanMotorSize.CHILDREN',
        OPT_SUNITEFFICIENCY: 'Opt_sUnitEfficiency',
        OPT_BSTAINLESSSTEEL_EXCHANGER: 'OPT_bStainlessSteel_Exchanger',
        OPT_BBAROMETRICRELIEF: 'OPT_bBarometricRelief',
        OPT_BEXTENDEDSECTION: 'OPT_bExtendedSection',
        OPT_BLOWSTATICEXHAUSTFAN: 'OPT_bLowStaticExhaustFan',
        OPT_BLOWSTATICEXHAUSTFAN_CHILDREN: 'OPT_bLowStaticExhaustFan.CHILDREN',
        OPT_BLOWSTATICEXHAUSTFAN_CONTROLTYPE_VALID: 'OPT_bLowStaticExhaustFan.CONTROLTYPE.VALID',
        OPT_BMEDSTATICEXHAUSTFAN: 'OPT_bMedStaticExhaustFan',
        OPT_BMEDSTATICEXHAUSTFAN_CHILDREN: 'OPT_bMedStaticExhaustFan.CHILDREN',
        OPT_BMODULATINGBPCONTROL: 'OPT_bModulatingBPControl',
        OPT_BOUTDOORAIRFLOW: 'OPT_bOutdoorAirflow',
        OPT_BSTDSTATICEXHAUSTFAN: 'OPT_bStdStaticExhaustFan',
        OPT_BSTDSTATICEXHAUSTFAN_CHILDREN: 'OPT_bStdStaticExhaustFan.CHILDREN',
        OPT_SCHASSIS: 'Opt_sChassis',
        OPT_SCOMPRESSOR: 'OPT_sCompressor',
        OPT_SMOTORSTATIC: 'OPT_sMotorStatic',
        OPT_SMOTORSTATIC_CHILDREN: 'OPT_sMotorStatic.CHILDREN',
        OPT_BPLENUMSECTION: 'OPT_bPlenumSection',
    },
    [TAGS.UI_SEL]: {
        BU_SAPPLICATIONTYPE: 'BU_sApplicationType',
        BU_SHEATCAPACITY: 'BU_sHeatCapacity',
        BU_SHEATTYPE: 'BU_sHeatType',
        BU_SMODEL: 'BU_sModel',
        TAG_SCONFIGRULESET: 'Tag_sConfigRuleset',
        BU_SSUPPLYRETURN: 'BU_sSupplyReturn',
        BU_SUNITSIZE: 'BU_sUnitSize',
        BU_SVOLTAGE: 'BU_sVoltage',
        DC_BCOOLING: 'DC_bCooling',
        DC_BHEATING: 'DC_bHeating',
        DC_BHEATINGLAT: 'DC_bHeatingLAT',
        DC_BSENSIBLECOOLING: 'DC_bSensibleCooling',
        DC_FALTITUDEFT_DISPLAYUNIT: 'DC_fAltitudeFt.DISPLAYUNIT',
        DC_FALTITUDEFT_UNIT: 'DC_fAltitudeFt.UNIT',
        DC_FCOOLING: 'DC_fCooling',
        DC_FCOOLING_DISPLAYUNIT: 'DC_fCooling.DISPLAYUNIT',
        DC_FCOOLING_UNIT: 'DC_fCooling.UNIT',
        DC_FEXTERNALSTATIC: 'DC_fExternalStatic',
        DC_FEXTERNALSTATIC_DISPLAYUNIT: 'DC_fExternalStatic.DISPLAYUNIT',
        DC_FEXTERNALSTATIC_UNIT: 'DC_fExternalStatic.UNIT',
        DC_FHEATING: 'DC_fHeating',
        DC_FHEATING_DISPLAYUNIT: 'DC_fHeating.DISPLAYUNIT',
        DC_FHEATING_UNIT: 'DC_fHeating.UNIT',
        DC_FHEATINGLAT: 'DC_fHeatingLAT',
        DC_FHEATINGLAT_DISPLAYUNIT: 'DC_fHeatingLAT.DISPLAYUNIT',
        DC_FHEATINGLAT_UNIT: 'DC_fHeatingLAT.UNIT',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING: 'DC_fMixedAir_EIC_DryBulbCooling',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fMixedAir_EIC_DryBulbCooling.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING_UNIT: 'DC_fMixedAir_EIC_DryBulbCooling.UNIT',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING: 'DC_fMixedAir_EIC_DryBulbHeating',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING_DISPLAYUNIT: 'DC_fMixedAir_EIC_DryBulbHeating.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING_UNIT: 'DC_fMixedAir_EIC_DryBulbHeating.UNIT',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING: 'DC_fMixedAir_EIC_WetBulbCooling',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING_DISPLAYUNIT: 'DC_fMixedAir_EIC_WetBulbCooling.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING_UNIT: 'DC_fMixedAir_EIC_WetBulbCooling.UNIT',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING: 'DC_fOutdoor_EOC_DryBulbCooling',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoor_EOC_DryBulbCooling.DISPLAYUNIT',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING_UNIT: 'DC_fOutdoor_EOC_DryBulbCooling.UNIT',
        DC_FOUTDOORAIR_DRYBULBCOOLING: 'DC_fOutdoorAir_DryBulbCooling',
        DC_FOUTDOORAIR_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoorAir_DryBulbCooling.DISPLAYUNIT',
        DC_FOUTDOORAIR_DRYBULBCOOLING_UNIT: 'DC_fOutdoorAir_DryBulbCooling.UNIT',
        DC_FOUTDOORAIR_DRYBULBHEATING: 'DC_fOutdoorAir_DryBulbHeating',
        DC_FOUTDOORAIR_DRYBULBHEATING_DISPLAYUNIT: 'DC_fOutdoorAir_DryBulbHeating.DISPLAYUNIT',
        DC_FOUTDOORAIR_DRYBULBHEATING_UNIT: 'DC_fOutdoorAir_DryBulbHeating.UNIT',
        DC_FOUTDOORAIR_WETBULBCOOLING: 'DC_fOutdoorAir_WetBulbCooling',
        DC_FOUTDOORAIR_WETBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoorAir_WetBulbCooling.DISPLAYUNIT',
        DC_FOUTDOORAIR_WETBULBCOOLING_UNIT: 'DC_fOutdoorAir_WetBulbCooling.UNIT',
        DC_FOUTDOORAIR_WETBULBHEATING: 'DC_fOutdoorAir_WetBulbHeating',
        DC_FOUTDOORAIR_WETBULBHEATING_DISPLAYUNIT: 'DC_fOutdoorAir_WetBulbHeating.DISPLAYUNIT',
        DC_FOUTDOORAIR_WETBULBHEATING_UNIT: 'DC_fOutdoorAir_WetBulbHeating.UNIT',
        DC_FOUTDOORAIRCFM: 'DC_fOutdoorAirCFM',
        DC_FOUTDOORAIRCFM_DISPLAYUNIT: 'DC_fOutdoorAirCFM.DISPLAYUNIT',
        DC_FOUTDOORAIRCFM_UNIT: 'DC_fOutdoorAirCFM.UNIT',
        DC_FPOWEREXHAUSTAIRFLOW: 'DC_fPowerExhaustAirFlow',
        DC_FPOWEREXHAUSTAIRFLOW_DISPLAYUNIT: 'DC_fPowerExhaustAirFlow.DISPLAYUNIT',
        DC_FPOWEREXHAUSTAIRFLOW_UNIT: 'DC_fPowerExhaustAirFlow.UNIT',
        DC_FRETURNAIR_DRYBULBCOOLING: 'DC_fReturnAir_DryBulbCooling',
        DC_FRETURNAIR_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fReturnAir_DryBulbCooling.DISPLAYUNIT',
        DC_FRETURNAIR_DRYBULBCOOLING_UNIT: 'DC_fReturnAir_DryBulbCooling.UNIT',
        DC_FRETURNAIR_DRYBULBHEATING: 'DC_fReturnAir_DryBulbHeating',
        DC_FRETURNAIR_DRYBULBHEATING_DISPLAYUNIT: 'DC_fReturnAir_DryBulbHeating.DISPLAYUNIT',
        DC_FRETURNAIR_DRYBULBHEATING_UNIT: 'DC_fReturnAir_DryBulbHeating.UNIT',
        DC_FRETURNAIR_WETBULBCOOLING: 'DC_fReturnAir_WetBulbCooling',
        DC_FRETURNAIR_WETBULBCOOLING_DISPLAYUNIT: 'DC_fReturnAir_WetBulbCooling.DISPLAYUNIT',
        DC_FRETURNAIR_WETBULBCOOLING_UNIT: 'DC_fReturnAir_WetBulbCooling.UNIT',
        DC_FRETURNAIR_WETBULBHEATING: 'DC_fReturnAir_WetBulbHeating',
        DC_FRETURNAIR_WETBULBHEATING_DISPLAYUNIT: 'DC_fReturnAir_WetBulbHeating.DISPLAYUNIT',
        DC_FRETURNAIR_WETBULBHEATING_UNIT: 'DC_fReturnAir_WetBulbHeating.UNIT',
        DC_FSENSIBLECOOLING: 'DC_fSensibleCooling',
        DC_FSENSIBLECOOLING_DISPLAYUNIT: 'DC_fSensibleCooling.DISPLAYUNIT',
        DC_FSENSIBLECOOLING_UNIT: 'DC_fSensibleCooling.UNIT',
        DC_FSUPPLYAIRFLOW: 'DC_fSupplyAirFlow',
        DC_FSUPPLYAIRFLOW_DISPLAYUNIT: 'DC_fSupplyAirFlow.DISPLAYUNIT',
        DC_FSUPPLYAIRFLOW_UNIT: 'DC_fSupplyAirFlow.UNIT',
        DC_FSUPPLYHEATINGAIRFLOW: 'DC_fSupplyHeatingAirFlow',
        DC_FSUPPLYHEATINGAIRFLOW_DISPLAYUNIT: 'DC_fSupplyHeatingAirFlow.DISPLAYUNIT',
        DC_FSUPPLYHEATINGAIRFLOW_UNIT: 'DC_fSupplyHeatingAirFlow.UNIT',
        DC_SCOILCONDITIONMETHOD: 'DC_sCoilConditionMethod',
        DC_FHOTWATERENTERINGFLUIDTEMP: 'DC_fHotWaterEnteringFluidTemp',
        DC_FHOTWATERENTERINGFLUIDTEMP_DISPLAYUNIT: 'DC_fHotWaterEnteringFluidTemp.DISPLAYUNIT',
        DC_FHOTWATERENTERINGFLUIDTEMP_UNIT: 'DC_fHotWaterEnteringFluidTemp.UNIT',
        DC_FHOTWATERFLOWRATE: 'DC_fHotWaterFlowRate',
        DC_FHOTWATERFLOWRATE_DISPLAYUNIT: 'DC_fHotWaterFlowRate.DISPLAYUNIT',
        DC_FHOTWATERFLOWRATE_UNIT: 'DC_fHotWaterFlowRate.UNIT',
        DC_FHOTWATERTEMPDROP: 'DC_fHotWaterTempDrop',
        DC_FHOTWATERTEMPDROP_DISPLAYUNIT: 'DC_fHotWaterTempDrop.DISPLAYUNIT',
        DC_FHOTWATERTEMPDROP_UNIT: 'DC_fHotWaterTempDrop.UNIT',
        DC_SHOTWATERFLOWRATE: 'DC_sHotWaterFlowRate',
        DC_SHOTWATERFLUID: 'DC_sHotwaterFluid',
        DC_SHOTWATERVALVETYPE: 'DC_sHotwaterValveType',
        DC_SCITY: 'DC_sCity',
        DC_SLOCATION: 'DC_sLocation',
    },
    [TAGS.UI_SEL_REQ]: {
        BU_SAPPLICATIONTYPE: 'BU_sApplicationType',
        BU_SHEATCAPACITY: 'BU_sHeatCapacity',
        BU_SHEATTYPE: 'BU_sHeatType',
        BU_SMODEL: 'BU_sModel',
        BU_SSUPPLYRETURN: 'BU_sSupplyReturn',
        BU_SUNITSIZE: 'BU_sUnitSize',
        BU_SVOLTAGE: 'BU_sVoltage',
    },
    [TAGS.UI_SEL_REQ_REQ]: {
        BU_SAPPLICATIONTYPE: 'BU_sApplicationType',
        BU_SHEATCAPACITY: 'BU_sHeatCapacity',
        BU_SHEATTYPE: 'BU_sHeatType',
        BU_SSUPPLYRETURN: 'BU_sSupplyReturn',
    },
    [TAGS.UI_SEL_REQ_MODEL]: {
        BU_SMODEL: 'BU_sModel',
        BU_SUNITSIZE: 'BU_sUnitSize',
        BU_SVOLTAGE: 'BU_sVoltage',
    },
    [TAGS.OPT_CAT_HUMIDIMIZER]: {
        DC_BCHECKHUMIDIMIZERFORM: 'DC_bCheckHumidimizerForm',
        DC_BCHECKMAXCOOLING: 'DC_bCheckMaxCooling',
        DC_BCHECKMAXDEHUMIDIFICATION: 'DC_bCheckMaxDeHumidification',
        DC_BCHECKPARTLOADHUMIDIFICATION: 'DC_bCheckPartLoadHumidification',
        DC_FMAXDEHUMCONDENSERENTTEMP: 'DC_fMaxDeHumCondenserEntTemp',
        DC_FMAXDEHUMCONDENSERENTTEMP_DISPLAYUNIT: 'DC_fMaxDeHumCondenserEntTemp.DISPLAYUNIT',
        DC_FMAXDEHUMCONDENSERENTTEMP_UNIT: 'DC_fMaxDeHumCondenserEntTemp.UNIT',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB: 'DC_fMaxDeHumEvapEntTempDryBulb',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB_DISPLAYUNIT: 'DC_fMaxDeHumEvapEntTempDryBulb.DISPLAYUNIT',
        DC_FMAXDEHUMEVAPENTTEMPDRYBULB_UNIT: 'DC_fMaxDeHumEvapEntTempDryBulb.UNIT',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB: 'DC_fMaxDeHumEvapEntTempWetBulb',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB_DISPLAYUNIT: 'DC_fMaxDeHumEvapEntTempWetBulb.DISPLAYUNIT',
        DC_FMAXDEHUMEVAPENTTEMPWETBULB_UNIT: 'DC_fMaxDeHumEvapEntTempWetBulb.UNIT',
        DC_FPLCONDENSERENTTEMP: 'DC_fPLCondenserEntTemp',
        DC_FPLCONDENSERENTTEMP_DISPLAYUNIT: 'DC_fPLCondenserEntTemp.DISPLAYUNIT',
        DC_FPLCONDENSERENTTEMP_UNIT: 'DC_fPLCondenserEntTemp.UNIT',
        DC_FPLEVAPENTTEMPDRYBULB: 'DC_fPLEvapEntTempDryBulb',
        DC_FPLEVAPENTTEMPDRYBULB_DISPLAYUNIT: 'DC_fPLEvapEntTempDryBulb.DISPLAYUNIT',
        DC_FPLEVAPENTTEMPDRYBULB_UNIT: 'DC_fPLEvapEntTempDryBulb.UNIT',
        DC_FPLEVAPENTTEMPWETBULB: 'DC_fPLEvapEntTempWetBulb',
        DC_FPLEVAPENTTEMPWETBULB_DISPLAYUNIT: 'DC_fPLEvapEntTempWetBulb.DISPLAYUNIT',
        DC_FPLEVAPENTTEMPWETBULB_UNIT: 'DC_fPLEvapEntTempWetBulb.UNIT',
    },
    [TAGS.UI_SEL_DC]: {
        DC_BCOOLING: 'DC_bCooling',
        DC_BHEATING: 'DC_bHeating',
        DC_BHEATINGLAT: 'DC_bHeatingLAT',
        DC_BSENSIBLECOOLING: 'DC_bSensibleCooling',
        DC_FALTITUDEFT_DISPLAYUNIT: 'DC_fAltitudeFt.DISPLAYUNIT',
        DC_FALTITUDEFT_UNIT: 'DC_fAltitudeFt.UNIT',
        DC_FCOOLING: 'DC_fCooling',
        DC_FCOOLING_DISPLAYUNIT: 'DC_fCooling.DISPLAYUNIT',
        DC_FCOOLING_UNIT: 'DC_fCooling.UNIT',
        DC_FEXTERNALSTATIC: 'DC_fExternalStatic',
        DC_FEXTERNALSTATIC_DISPLAYUNIT: 'DC_fExternalStatic.DISPLAYUNIT',
        DC_FEXTERNALSTATIC_UNIT: 'DC_fExternalStatic.UNIT',
        DC_FHEATING: 'DC_fHeating',
        DC_FHEATING_DISPLAYUNIT: 'DC_fHeating.DISPLAYUNIT',
        DC_FHEATING_UNIT: 'DC_fHeating.UNIT',
        DC_FHEATINGLAT: 'DC_fHeatingLAT',
        DC_FHEATINGLAT_DISPLAYUNIT: 'DC_fHeatingLAT.DISPLAYUNIT',
        DC_FHEATINGLAT_UNIT: 'DC_fHeatingLAT.UNIT',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING: 'DC_fMixedAir_EIC_DryBulbCooling',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fMixedAir_EIC_DryBulbCooling.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING_UNIT: 'DC_fMixedAir_EIC_DryBulbCooling.UNIT',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING: 'DC_fMixedAir_EIC_DryBulbHeating',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING_DISPLAYUNIT: 'DC_fMixedAir_EIC_DryBulbHeating.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING_UNIT: 'DC_fMixedAir_EIC_DryBulbHeating.UNIT',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING: 'DC_fMixedAir_EIC_WetBulbCooling',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING_DISPLAYUNIT: 'DC_fMixedAir_EIC_WetBulbCooling.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING_UNIT: 'DC_fMixedAir_EIC_WetBulbCooling.UNIT',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING: 'DC_fOutdoor_EOC_DryBulbCooling',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoor_EOC_DryBulbCooling.DISPLAYUNIT',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING_UNIT: 'DC_fOutdoor_EOC_DryBulbCooling.UNIT',
        DC_FOUTDOORAIR_DRYBULBCOOLING: 'DC_fOutdoorAir_DryBulbCooling',
        DC_FOUTDOORAIR_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoorAir_DryBulbCooling.DISPLAYUNIT',
        DC_FOUTDOORAIR_DRYBULBCOOLING_UNIT: 'DC_fOutdoorAir_DryBulbCooling.UNIT',
        DC_FOUTDOORAIR_DRYBULBHEATING: 'DC_fOutdoorAir_DryBulbHeating',
        DC_FOUTDOORAIR_DRYBULBHEATING_DISPLAYUNIT: 'DC_fOutdoorAir_DryBulbHeating.DISPLAYUNIT',
        DC_FOUTDOORAIR_DRYBULBHEATING_UNIT: 'DC_fOutdoorAir_DryBulbHeating.UNIT',
        DC_FOUTDOORAIR_WETBULBCOOLING: 'DC_fOutdoorAir_WetBulbCooling',
        DC_FOUTDOORAIR_WETBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoorAir_WetBulbCooling.DISPLAYUNIT',
        DC_FOUTDOORAIR_WETBULBCOOLING_UNIT: 'DC_fOutdoorAir_WetBulbCooling.UNIT',
        DC_FOUTDOORAIR_WETBULBHEATING: 'DC_fOutdoorAir_WetBulbHeating',
        DC_FOUTDOORAIR_WETBULBHEATING_DISPLAYUNIT: 'DC_fOutdoorAir_WetBulbHeating.DISPLAYUNIT',
        DC_FOUTDOORAIR_WETBULBHEATING_UNIT: 'DC_fOutdoorAir_WetBulbHeating.UNIT',
        DC_FOUTDOORAIRCFM: 'DC_fOutdoorAirCFM',
        DC_FOUTDOORAIRCFM_DISPLAYUNIT: 'DC_fOutdoorAirCFM.DISPLAYUNIT',
        DC_FOUTDOORAIRCFM_UNIT: 'DC_fOutdoorAirCFM.UNIT',
        DC_FPOWEREXHAUSTAIRFLOW: 'DC_fPowerExhaustAirFlow',
        DC_FPOWEREXHAUSTAIRFLOW_DISPLAYUNIT: 'DC_fPowerExhaustAirFlow.DISPLAYUNIT',
        DC_FPOWEREXHAUSTAIRFLOW_UNIT: 'DC_fPowerExhaustAirFlow.UNIT',
        DC_FRETURNAIR_DRYBULBCOOLING: 'DC_fReturnAir_DryBulbCooling',
        DC_FRETURNAIR_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fReturnAir_DryBulbCooling.DISPLAYUNIT',
        DC_FRETURNAIR_DRYBULBCOOLING_UNIT: 'DC_fReturnAir_DryBulbCooling.UNIT',
        DC_FRETURNAIR_DRYBULBHEATING: 'DC_fReturnAir_DryBulbHeating',
        DC_FRETURNAIR_DRYBULBHEATING_DISPLAYUNIT: 'DC_fReturnAir_DryBulbHeating.DISPLAYUNIT',
        DC_FRETURNAIR_DRYBULBHEATING_UNIT: 'DC_fReturnAir_DryBulbHeating.UNIT',
        DC_FRETURNAIR_WETBULBCOOLING: 'DC_fReturnAir_WetBulbCooling',
        DC_FRETURNAIR_WETBULBCOOLING_DISPLAYUNIT: 'DC_fReturnAir_WetBulbCooling.DISPLAYUNIT',
        DC_FRETURNAIR_WETBULBCOOLING_UNIT: 'DC_fReturnAir_WetBulbCooling.UNIT',
        DC_FRETURNAIR_WETBULBHEATING: 'DC_fReturnAir_WetBulbHeating',
        DC_FRETURNAIR_WETBULBHEATING_DISPLAYUNIT: 'DC_fReturnAir_WetBulbHeating.DISPLAYUNIT',
        DC_FRETURNAIR_WETBULBHEATING_UNIT: 'DC_fReturnAir_WetBulbHeating.UNIT',
        DC_FSENSIBLECOOLING: 'DC_fSensibleCooling',
        DC_FSENSIBLECOOLING_DISPLAYUNIT: 'DC_fSensibleCooling.DISPLAYUNIT',
        DC_FSENSIBLECOOLING_UNIT: 'DC_fSensibleCooling.UNIT',
        DC_FSUPPLYAIRFLOW: 'DC_fSupplyAirFlow',
        DC_FSUPPLYAIRFLOW_DISPLAYUNIT: 'DC_fSupplyAirFlow.DISPLAYUNIT',
        DC_FSUPPLYAIRFLOW_UNIT: 'DC_fSupplyAirFlow.UNIT',
        DC_FSUPPLYHEATINGAIRFLOW: 'DC_fSupplyHeatingAirFlow',
        DC_FSUPPLYHEATINGAIRFLOW_DISPLAYUNIT: 'DC_fSupplyHeatingAirFlow.DISPLAYUNIT',
        DC_FSUPPLYHEATINGAIRFLOW_UNIT: 'DC_fSupplyHeatingAirFlow.UNIT',
        DC_SCOILCONDITIONMETHOD: 'DC_sCoilConditionMethod',
        DC_FHOTWATERENTERINGFLUIDTEMP: 'DC_fHotWaterEnteringFluidTemp',
        DC_FHOTWATERENTERINGFLUIDTEMP_DISPLAYUNIT: 'DC_fHotWaterEnteringFluidTemp.DISPLAYUNIT',
        DC_FHOTWATERENTERINGFLUIDTEMP_UNIT: 'DC_fHotWaterEnteringFluidTemp.UNIT',
        DC_FHOTWATERFLOWRATE: 'DC_fHotWaterFlowRate',
        DC_FHOTWATERFLOWRATE_DISPLAYUNIT: 'DC_fHotWaterFlowRate.DISPLAYUNIT',
        DC_FHOTWATERFLOWRATE_UNIT: 'DC_fHotWaterFlowRate.UNIT',
        DC_FHOTWATERTEMPDROP: 'DC_fHotWaterTempDrop',
        DC_FHOTWATERTEMPDROP_DISPLAYUNIT: 'DC_fHotWaterTempDrop.DISPLAYUNIT',
        DC_FHOTWATERTEMPDROP_UNIT: 'DC_fHotWaterTempDrop.UNIT',
        DC_SHOTWATERFLOWRATE: 'DC_sHotWaterFlowRate',
        DC_SHOTWATERFLUID: 'DC_sHotwaterFluid',
        DC_SHOTWATERVALVETYPE: 'DC_sHotwaterValveType',
        DC_SCITY: 'DC_sCity',
        DC_SLOCATION: 'DC_sLocation',
    },
    [TAGS.UI_SEL_DC_CAPREQ]: {
        DC_BCOOLING: 'DC_bCooling',
        DC_BHEATING: 'DC_bHeating',
        DC_BHEATINGLAT: 'DC_bHeatingLAT',
        DC_BSENSIBLECOOLING: 'DC_bSensibleCooling',
        DC_FCOOLING: 'DC_fCooling',
        DC_FCOOLING_DISPLAYUNIT: 'DC_fCooling.DISPLAYUNIT',
        DC_FCOOLING_UNIT: 'DC_fCooling.UNIT',
        DC_FHEATING: 'DC_fHeating',
        DC_FHEATING_DISPLAYUNIT: 'DC_fHeating.DISPLAYUNIT',
        DC_FHEATING_UNIT: 'DC_fHeating.UNIT',
        DC_FHEATINGLAT: 'DC_fHeatingLAT',
        DC_FHEATINGLAT_DISPLAYUNIT: 'DC_fHeatingLAT.DISPLAYUNIT',
        DC_FHEATINGLAT_UNIT: 'DC_fHeatingLAT.UNIT',
        DC_FSENSIBLECOOLING: 'DC_fSensibleCooling',
        DC_FSENSIBLECOOLING_DISPLAYUNIT: 'DC_fSensibleCooling.DISPLAYUNIT',
        DC_FSENSIBLECOOLING_UNIT: 'DC_fSensibleCooling.UNIT',
    },
    [TAGS.DC]: {
        DC_FALTITUDEFT: 'DC_fAltitudeFt',
        MLP_BU_SAPPLICATIONTYPE: 'MLP_BU_sApplicationType',
        MLP_BU_SHEATCAPACITY: 'MLP_BU_sHeatCapacity',
        MLP_FBASEUNIT: 'MLP_fBaseUnit',
        MLP_FOPT_BBOTTOMCONSTRUCTION: 'MLP_fOPT_bBottomConstruction',
        MLP_FOPT_BCONDENSEOVERFLOWSWITCH: 'MLP_fOPT_bCondenseOverflowSwitch',
        MLP_FOPT_BDIGITALCOMPRESSOR: 'MLP_fOpt_bDigitalCompressor',
        MLP_FOPT_BDRAINPANTYPES: 'MLP_fOPT_bDrainPanTypes',
        MLP_FOPT_BHAILGUARD: 'MLP_fOPT_bHailGuard',
        MLP_FOPT_BHUMIDIMIZER: 'MLP_fOPT_bHumidimizer',
        MLP_FOPT_BHUMIDITYSENSORS: 'MLP_fOPT_bHumiditySensors',
        MLP_FOPT_BIAQOPTIONS: 'MLP_fOPT_bIAQOptions',
        MLP_FOPT_BLOWAMBIENT: 'MLP_fOPT_bLowAmbient',
        MLP_FOPT_BLOWSOUNDCNDFANS: 'MLP_fOPT_bLowSoundCndFans',
        MLP_FOPT_BMOTORPROTECTION: 'MLP_fOpt_bMotorProtection',
        MLP_FOPT_BNONFUSEDDISCONNECT: 'MLP_fOPT_bNonFusedDisconnect',
        MLP_FOPT_BOUTDOORAIRMEASURE: 'MLP_fOPT_bOutdoorAirMeasure',
        MLP_FOPT_BPHASEMONITOR: 'MLP_fOPT_bPhaseMonitor',
        MLP_FOPT_BREFRIGERANTRELIEFVALUE: 'MLP_fOPT_bRefrigerantReliefValue',
        MLP_FOPT_BRETURNAIRCO2SENSOR: 'MLP_fOPT_bReturnAirCO2Sensor',
        MLP_FOPT_BRETURNAIRSMOKEDETECTOR: 'MLP_fOPT_bReturnAirSmokeDetector',
        MLP_FOPT_BSERVICEPACK: 'MLP_fOPT_bServicePack',
        MLP_FOPT_BSUPPLYFANMOTOR: 'MLP_fOpt_bSupplyFanMotor',
        MLP_FOPT_BTERMINALBLOCK: 'MLP_fOPT_bTerminalBlock',
        MLP_FOPT_BVFDBYPASS: 'MLP_fOpt_bVfdBypass',
        MLP_FOPT_SCOILFINCOATING: 'MLP_fOpt_sCoilFinCoating',
        MLP_FOPT_SCONSTRUCTION: 'MLP_fOPT_sConstruction',
        MLP_FOPT_SCONVENIENCEOUTLET: 'MLP_fOpt_sConvenienceOutlet',
        MLP_FOPT_SHEATOPTION: 'MLP_fOPT_sHeatOption',
        MLP_FOPT_SOUTDOORAIR: 'MLP_fOpt_sOutdoorAir',
        MLP_FOPT_SPREFILTERMSTYPES: 'MLP_fOPT_sPreFilterMSTypes',
        MLP_FOPT_SPREFILTERTYPES: 'MLP_fOPT_sPreFilterTypes',
        MLP_FOPT_SRELIEFTYPE: 'MLP_fOPT_sReliefType',
        MLP_FOPT_SSCCR: 'MLP_fOPT_sSCCR',
        MLP_FOPT_SSUPPLYFANMOTORSIZE: 'MLP_fOpt_sSupplyFanMotorSize',
        MLP_FOPT_SUNITEFFICIENCY: 'MLP_fOpt_sUnitEfficiency',
        MLP_FOPT_BSTAINLESSSTEEL_EXCHANGER: 'MLP_fOPT_bStainlessSteel_Exchanger',
        MLP_FOPT_BBAROMETRICRELIEF: 'MLP_fOPT_bBarometricRelief',
        MLP_FOPT_BEXTENDEDSECTION: 'MLP_fOPT_bExtendedSection',
        MLP_FOPT_BLOWSTATICEXHAUSTFAN: 'MLP_fOPT_bLowStaticExhaustFan',
        MLP_FOPT_BMEDSTATICEXHAUSTFAN: 'MLP_fOPT_bMedStaticExhaustFan',
        MLP_FOPT_BMODULATINGBPCONTROL: 'MLP_fOPT_bModulatingBPControl',
        MLP_FOPT_BOPTIONALCONTROLS: 'MLP_fOPT_bOptionalControls',
        MLP_FOPT_BOUTDOORAIRFLOW: 'MLP_fOPT_bOutdoorAirflow',
        MLP_FOPT_BPLENUMSECTION: 'MLP_fOPT_bPlenumSection',
        MLP_FOPT_BSTDSTATICEXHAUSTFAN: 'MLP_fOPT_bStdStaticExhaustFan',
        MLP_FOPT_SCHASSIS: 'MLP_fOpt_sChassis',
        MLP_FOPT_SMOTORSTATIC: 'MLP_fOPT_sMotorStatic',
        MLP_FOPT_SSOUNDOPTION: 'MLP_fOPT_sSoundOption',
    },
    [TAGS.REPORT]: {
        DC_FALTITUDEFT: 'DC_fAltitudeFt',
        MLP_BU_SAPPLICATIONTYPE: 'MLP_BU_sApplicationType',
        MLP_BU_SHEATCAPACITY: 'MLP_BU_sHeatCapacity',
        MLP_FBASEUNIT: 'MLP_fBaseUnit',
        MLP_FOPT_BBOTTOMCONSTRUCTION: 'MLP_fOPT_bBottomConstruction',
        MLP_FOPT_BCONDENSEOVERFLOWSWITCH: 'MLP_fOPT_bCondenseOverflowSwitch',
        MLP_FOPT_BDIGITALCOMPRESSOR: 'MLP_fOpt_bDigitalCompressor',
        MLP_FOPT_BDRAINPANTYPES: 'MLP_fOPT_bDrainPanTypes',
        MLP_FOPT_BHAILGUARD: 'MLP_fOPT_bHailGuard',
        MLP_FOPT_BHUMIDIMIZER: 'MLP_fOPT_bHumidimizer',
        MLP_FOPT_BHUMIDITYSENSORS: 'MLP_fOPT_bHumiditySensors',
        MLP_FOPT_BIAQOPTIONS: 'MLP_fOPT_bIAQOptions',
        MLP_FOPT_BLOWAMBIENT: 'MLP_fOPT_bLowAmbient',
        MLP_FOPT_BLOWSOUNDCNDFANS: 'MLP_fOPT_bLowSoundCndFans',
        MLP_FOPT_BMOTORPROTECTION: 'MLP_fOpt_bMotorProtection',
        MLP_FOPT_BNONFUSEDDISCONNECT: 'MLP_fOPT_bNonFusedDisconnect',
        MLP_FOPT_BOUTDOORAIRMEASURE: 'MLP_fOPT_bOutdoorAirMeasure',
        MLP_FOPT_BPHASEMONITOR: 'MLP_fOPT_bPhaseMonitor',
        MLP_FOPT_BREFRIGERANTRELIEFVALUE: 'MLP_fOPT_bRefrigerantReliefValue',
        MLP_FOPT_BRETURNAIRCO2SENSOR: 'MLP_fOPT_bReturnAirCO2Sensor',
        MLP_FOPT_BRETURNAIRSMOKEDETECTOR: 'MLP_fOPT_bReturnAirSmokeDetector',
        MLP_FOPT_BSERVICEPACK: 'MLP_fOPT_bServicePack',
        MLP_FOPT_BSUPPLYFANMOTOR: 'MLP_fOpt_bSupplyFanMotor',
        MLP_FOPT_BTERMINALBLOCK: 'MLP_fOPT_bTerminalBlock',
        MLP_FOPT_BVFDBYPASS: 'MLP_fOpt_bVfdBypass',
        MLP_FOPT_SCOILFINCOATING: 'MLP_fOpt_sCoilFinCoating',
        MLP_FOPT_SCONSTRUCTION: 'MLP_fOPT_sConstruction',
        MLP_FOPT_SCONVENIENCEOUTLET: 'MLP_fOpt_sConvenienceOutlet',
        MLP_FOPT_SHEATOPTION: 'MLP_fOPT_sHeatOption',
        MLP_FOPT_SOUTDOORAIR: 'MLP_fOpt_sOutdoorAir',
        MLP_FOPT_SPREFILTERMSTYPES: 'MLP_fOPT_sPreFilterMSTypes',
        MLP_FOPT_SPREFILTERTYPES: 'MLP_fOPT_sPreFilterTypes',
        MLP_FOPT_SRELIEFTYPE: 'MLP_fOPT_sReliefType',
        MLP_FOPT_SSCCR: 'MLP_fOPT_sSCCR',
        MLP_FOPT_SSUPPLYFANMOTORSIZE: 'MLP_fOpt_sSupplyFanMotorSize',
        MLP_FOPT_SUNITEFFICIENCY: 'MLP_fOpt_sUnitEfficiency',
        MLP_FOPT_BSTAINLESSSTEEL_EXCHANGER: 'MLP_fOPT_bStainlessSteel_Exchanger',
        MLP_FOPT_BBAROMETRICRELIEF: 'MLP_fOPT_bBarometricRelief',
        MLP_FOPT_BEXTENDEDSECTION: 'MLP_fOPT_bExtendedSection',
        MLP_FOPT_BLOWSTATICEXHAUSTFAN: 'MLP_fOPT_bLowStaticExhaustFan',
        MLP_FOPT_BMEDSTATICEXHAUSTFAN: 'MLP_fOPT_bMedStaticExhaustFan',
        MLP_FOPT_BMODULATINGBPCONTROL: 'MLP_fOPT_bModulatingBPControl',
        MLP_FOPT_BOPTIONALCONTROLS: 'MLP_fOPT_bOptionalControls',
        MLP_FOPT_BOUTDOORAIRFLOW: 'MLP_fOPT_bOutdoorAirflow',
        MLP_FOPT_BPLENUMSECTION: 'MLP_fOPT_bPlenumSection',
        MLP_FOPT_BSTDSTATICEXHAUSTFAN: 'MLP_fOPT_bStdStaticExhaustFan',
        MLP_FOPT_SCHASSIS: 'MLP_fOpt_sChassis',
        MLP_FOPT_SMOTORSTATIC: 'MLP_fOPT_sMotorStatic',
        MLP_FOPT_SSOUNDOPTION: 'MLP_fOPT_sSoundOption',
    },
    [TAGS.UI_DESCRIT]: {
        DC_FALTITUDEFT: 'DC_fAltitudeFt',
    },
    [TAGS.UI_DESCRIT_UNIT]: {
        DC_FALTITUDEFT: 'DC_fAltitudeFt',
    },
    [TAGS.UI_SEL_DC_UNIT]: {
        DC_FALTITUDEFT_DISPLAYUNIT: 'DC_fAltitudeFt.DISPLAYUNIT',
        DC_FALTITUDEFT_UNIT: 'DC_fAltitudeFt.UNIT',
        DC_FEXTERNALSTATIC: 'DC_fExternalStatic',
        DC_FEXTERNALSTATIC_DISPLAYUNIT: 'DC_fExternalStatic.DISPLAYUNIT',
        DC_FEXTERNALSTATIC_UNIT: 'DC_fExternalStatic.UNIT',
        DC_FSUPPLYAIRFLOW: 'DC_fSupplyAirFlow',
        DC_FSUPPLYAIRFLOW_DISPLAYUNIT: 'DC_fSupplyAirFlow.DISPLAYUNIT',
        DC_FSUPPLYAIRFLOW_UNIT: 'DC_fSupplyAirFlow.UNIT',
        DC_FSUPPLYHEATINGAIRFLOW: 'DC_fSupplyHeatingAirFlow',
        DC_FSUPPLYHEATINGAIRFLOW_DISPLAYUNIT: 'DC_fSupplyHeatingAirFlow.DISPLAYUNIT',
        DC_FSUPPLYHEATINGAIRFLOW_UNIT: 'DC_fSupplyHeatingAirFlow.UNIT',
    },
    [TAGS.UI_SEL_DC_COND]: {
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING: 'DC_fMixedAir_EIC_DryBulbCooling',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fMixedAir_EIC_DryBulbCooling.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_DRYBULBCOOLING_UNIT: 'DC_fMixedAir_EIC_DryBulbCooling.UNIT',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING: 'DC_fMixedAir_EIC_DryBulbHeating',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING_DISPLAYUNIT: 'DC_fMixedAir_EIC_DryBulbHeating.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_DRYBULBHEATING_UNIT: 'DC_fMixedAir_EIC_DryBulbHeating.UNIT',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING: 'DC_fMixedAir_EIC_WetBulbCooling',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING_DISPLAYUNIT: 'DC_fMixedAir_EIC_WetBulbCooling.DISPLAYUNIT',
        DC_FMIXEDAIR_EIC_WETBULBCOOLING_UNIT: 'DC_fMixedAir_EIC_WetBulbCooling.UNIT',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING: 'DC_fOutdoor_EOC_DryBulbCooling',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoor_EOC_DryBulbCooling.DISPLAYUNIT',
        DC_FOUTDOOR_EOC_DRYBULBCOOLING_UNIT: 'DC_fOutdoor_EOC_DryBulbCooling.UNIT',
        DC_FOUTDOORAIR_DRYBULBCOOLING: 'DC_fOutdoorAir_DryBulbCooling',
        DC_FOUTDOORAIR_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoorAir_DryBulbCooling.DISPLAYUNIT',
        DC_FOUTDOORAIR_DRYBULBCOOLING_UNIT: 'DC_fOutdoorAir_DryBulbCooling.UNIT',
        DC_FOUTDOORAIR_DRYBULBHEATING: 'DC_fOutdoorAir_DryBulbHeating',
        DC_FOUTDOORAIR_DRYBULBHEATING_DISPLAYUNIT: 'DC_fOutdoorAir_DryBulbHeating.DISPLAYUNIT',
        DC_FOUTDOORAIR_DRYBULBHEATING_UNIT: 'DC_fOutdoorAir_DryBulbHeating.UNIT',
        DC_FOUTDOORAIR_WETBULBCOOLING: 'DC_fOutdoorAir_WetBulbCooling',
        DC_FOUTDOORAIR_WETBULBCOOLING_DISPLAYUNIT: 'DC_fOutdoorAir_WetBulbCooling.DISPLAYUNIT',
        DC_FOUTDOORAIR_WETBULBCOOLING_UNIT: 'DC_fOutdoorAir_WetBulbCooling.UNIT',
        DC_FOUTDOORAIR_WETBULBHEATING: 'DC_fOutdoorAir_WetBulbHeating',
        DC_FOUTDOORAIR_WETBULBHEATING_DISPLAYUNIT: 'DC_fOutdoorAir_WetBulbHeating.DISPLAYUNIT',
        DC_FOUTDOORAIR_WETBULBHEATING_UNIT: 'DC_fOutdoorAir_WetBulbHeating.UNIT',
        DC_FOUTDOORAIRCFM: 'DC_fOutdoorAirCFM',
        DC_FOUTDOORAIRCFM_DISPLAYUNIT: 'DC_fOutdoorAirCFM.DISPLAYUNIT',
        DC_FOUTDOORAIRCFM_UNIT: 'DC_fOutdoorAirCFM.UNIT',
        DC_FPOWEREXHAUSTAIRFLOW: 'DC_fPowerExhaustAirFlow',
        DC_FPOWEREXHAUSTAIRFLOW_DISPLAYUNIT: 'DC_fPowerExhaustAirFlow.DISPLAYUNIT',
        DC_FPOWEREXHAUSTAIRFLOW_UNIT: 'DC_fPowerExhaustAirFlow.UNIT',
        DC_FRETURNAIR_DRYBULBCOOLING: 'DC_fReturnAir_DryBulbCooling',
        DC_FRETURNAIR_DRYBULBCOOLING_DISPLAYUNIT: 'DC_fReturnAir_DryBulbCooling.DISPLAYUNIT',
        DC_FRETURNAIR_DRYBULBCOOLING_UNIT: 'DC_fReturnAir_DryBulbCooling.UNIT',
        DC_FRETURNAIR_DRYBULBHEATING: 'DC_fReturnAir_DryBulbHeating',
        DC_FRETURNAIR_DRYBULBHEATING_DISPLAYUNIT: 'DC_fReturnAir_DryBulbHeating.DISPLAYUNIT',
        DC_FRETURNAIR_DRYBULBHEATING_UNIT: 'DC_fReturnAir_DryBulbHeating.UNIT',
        DC_FRETURNAIR_WETBULBCOOLING: 'DC_fReturnAir_WetBulbCooling',
        DC_FRETURNAIR_WETBULBCOOLING_DISPLAYUNIT: 'DC_fReturnAir_WetBulbCooling.DISPLAYUNIT',
        DC_FRETURNAIR_WETBULBCOOLING_UNIT: 'DC_fReturnAir_WetBulbCooling.UNIT',
        DC_FRETURNAIR_WETBULBHEATING: 'DC_fReturnAir_WetBulbHeating',
        DC_FRETURNAIR_WETBULBHEATING_DISPLAYUNIT: 'DC_fReturnAir_WetBulbHeating.DISPLAYUNIT',
        DC_FRETURNAIR_WETBULBHEATING_UNIT: 'DC_fReturnAir_WetBulbHeating.UNIT',
        DC_SCOILCONDITIONMETHOD: 'DC_sCoilConditionMethod',
        DC_SCITY: 'DC_sCity',
        DC_SLOCATION: 'DC_sLocation',
    },
    [TAGS.UI_ALWAYS]: {
        MLP_ACC_FTOTAL: 'MLP_Acc_fTotal',
        MLP_BU_FTOTAL: 'MLP_BU_fTotal',
        MLP_FBASEUNIT: 'MLP_fBaseUnit',
        MLP_FTOTAL: 'MLP_fTotal',
        MLP_OPT_FTOTAL: 'MLP_Opt_fTotal',
        MLP_QC_FTOTAL: 'MLP_QC_fTotal',
        MLP_STARTUP_FTOTAL: 'MLP_Startup_fTotal',
        MLP_WAR_FTOTAL: 'MLP_War_fTotal',
        PN_SMODEL: 'PN_sModel',
        TAG_BCONFIGVALID: 'Tag_bConfigValid',
        TAG_NQTY: 'Tag_nQty',
        UI_CONFIG_VALID: 'UI_Config.VALID',
        UI_CONFIG_UNIT_VALID: 'UI_Config_Unit.VALID',
        UI_CONFIG_UNIT_ACCESSORIES_VALID: 'UI_Config_Unit_Accessories.VALID',
        UI_CONFIG_UNIT_ACO_VALID: 'UI_Config_Unit_ACO.VALID',
        UI_CONFIG_UNIT_OPTIONS_VALID: 'UI_Config_Unit_Options.VALID',
        UI_CONFIG_UNIT_PC_VALID: 'UI_Config_Unit_PC.VALID',
        UI_CONFIG_UNIT_STARTUP_VALID: 'UI_Config_Unit_Startup.VALID',
        UI_CONFIG_UNIT_WARRANTIES_VALID: 'UI_Config_Unit_Warranties.VALID',
        UI_REPORTS_VALID: 'UI_Reports.VALID',
        UI_SEL_VALID: 'UI_Sel.VALID',
        UI_SEL_DC_VALID: 'UI_Sel_DC.VALID',
        UI_SEL_DC_CAPREQ_VALID: 'UI_Sel_DC_CapReq.VALID',
        UI_SEL_DC_COILCOND_VALID: 'UI_Sel_DC_CoilCond.VALID',
        UI_SEL_DC_HOTWATER_VALID: 'UI_Sel_DC_HotWater.VALID',
        UI_SEL_DC_UNIT_VALID: 'UI_Sel_DC_Unit.VALID',
        UI_SEL_REQ_VALID: 'UI_Sel_Req.VALID',
        UI_SEL_REQ_AIRFLOW_VALID: 'UI_Sel_REQ_AIRFLOW.VALID',
        UI_SEL_REQ_MODEL_VALID: 'UI_Sel_Req_Model.VALID',
        UI_SEL_REQ_REQ_VALID: 'UI_Sel_Req_Req.VALID',
        UI_USER_VALID: 'UI_User.VALID',
        TAG_SCONFIGRULESET: 'Tag_sConfigRuleset',
    },
    [TAGS.OPT]: {
        MLP_BU_SAPPLICATIONTYPE: 'MLP_BU_sApplicationType',
        MLP_BU_SHEATCAPACITY: 'MLP_BU_sHeatCapacity',
        MLP_FBASEUNIT: 'MLP_fBaseUnit',
        MLP_FOPT_BBOTTOMCONSTRUCTION: 'MLP_fOPT_bBottomConstruction',
        MLP_FOPT_BCONDENSEOVERFLOWSWITCH: 'MLP_fOPT_bCondenseOverflowSwitch',
        MLP_FOPT_BDIGITALCOMPRESSOR: 'MLP_fOpt_bDigitalCompressor',
        MLP_FOPT_BDRAINPANTYPES: 'MLP_fOPT_bDrainPanTypes',
        MLP_FOPT_BHAILGUARD: 'MLP_fOPT_bHailGuard',
        MLP_FOPT_BHUMIDIMIZER: 'MLP_fOPT_bHumidimizer',
        MLP_FOPT_BHUMIDITYSENSORS: 'MLP_fOPT_bHumiditySensors',
        MLP_FOPT_BIAQOPTIONS: 'MLP_fOPT_bIAQOptions',
        MLP_FOPT_BLOWAMBIENT: 'MLP_fOPT_bLowAmbient',
        MLP_FOPT_BLOWSOUNDCNDFANS: 'MLP_fOPT_bLowSoundCndFans',
        MLP_FOPT_BMOTORPROTECTION: 'MLP_fOpt_bMotorProtection',
        MLP_FOPT_BNONFUSEDDISCONNECT: 'MLP_fOPT_bNonFusedDisconnect',
        MLP_FOPT_BOUTDOORAIRMEASURE: 'MLP_fOPT_bOutdoorAirMeasure',
        MLP_FOPT_BPHASEMONITOR: 'MLP_fOPT_bPhaseMonitor',
        MLP_FOPT_BREFRIGERANTRELIEFVALUE: 'MLP_fOPT_bRefrigerantReliefValue',
        MLP_FOPT_BRETURNAIRCO2SENSOR: 'MLP_fOPT_bReturnAirCO2Sensor',
        MLP_FOPT_BRETURNAIRSMOKEDETECTOR: 'MLP_fOPT_bReturnAirSmokeDetector',
        MLP_FOPT_BSERVICEPACK: 'MLP_fOPT_bServicePack',
        MLP_FOPT_BSUPPLYFANMOTOR: 'MLP_fOpt_bSupplyFanMotor',
        MLP_FOPT_BTERMINALBLOCK: 'MLP_fOPT_bTerminalBlock',
        MLP_FOPT_BVFDBYPASS: 'MLP_fOpt_bVfdBypass',
        MLP_FOPT_SCOILFINCOATING: 'MLP_fOpt_sCoilFinCoating',
        MLP_FOPT_SCONSTRUCTION: 'MLP_fOPT_sConstruction',
        MLP_FOPT_SCONVENIENCEOUTLET: 'MLP_fOpt_sConvenienceOutlet',
        MLP_FOPT_SHEATOPTION: 'MLP_fOPT_sHeatOption',
        MLP_FOPT_SOUTDOORAIR: 'MLP_fOpt_sOutdoorAir',
        MLP_FOPT_SPREFILTERMSTYPES: 'MLP_fOPT_sPreFilterMSTypes',
        MLP_FOPT_SPREFILTERTYPES: 'MLP_fOPT_sPreFilterTypes',
        MLP_FOPT_SRELIEFTYPE: 'MLP_fOPT_sReliefType',
        MLP_FOPT_SSCCR: 'MLP_fOPT_sSCCR',
        MLP_FOPT_SSUPPLYFANMOTORSIZE: 'MLP_fOpt_sSupplyFanMotorSize',
        MLP_FOPT_SUNITEFFICIENCY: 'MLP_fOpt_sUnitEfficiency',
        MLP_FOPT_BSTAINLESSSTEEL_EXCHANGER: 'MLP_fOPT_bStainlessSteel_Exchanger',
        MLP_FOPT_BBAROMETRICRELIEF: 'MLP_fOPT_bBarometricRelief',
        MLP_FOPT_BEXTENDEDSECTION: 'MLP_fOPT_bExtendedSection',
        MLP_FOPT_BLOWSTATICEXHAUSTFAN: 'MLP_fOPT_bLowStaticExhaustFan',
        MLP_FOPT_BMEDSTATICEXHAUSTFAN: 'MLP_fOPT_bMedStaticExhaustFan',
        MLP_FOPT_BMODULATINGBPCONTROL: 'MLP_fOPT_bModulatingBPControl',
        MLP_FOPT_BOPTIONALCONTROLS: 'MLP_fOPT_bOptionalControls',
        MLP_FOPT_BOUTDOORAIRFLOW: 'MLP_fOPT_bOutdoorAirflow',
        MLP_FOPT_BPLENUMSECTION: 'MLP_fOPT_bPlenumSection',
        MLP_FOPT_BSTDSTATICEXHAUSTFAN: 'MLP_fOPT_bStdStaticExhaustFan',
        MLP_FOPT_SCHASSIS: 'MLP_fOpt_sChassis',
        MLP_FOPT_SMOTORSTATIC: 'MLP_fOPT_sMotorStatic',
        MLP_FOPT_SSOUNDOPTION: 'MLP_fOPT_sSoundOption',
    },
    [TAGS.SC]: {
        MLP_BU_SAPPLICATIONTYPE: 'MLP_BU_sApplicationType',
        MLP_BU_SHEATCAPACITY: 'MLP_BU_sHeatCapacity',
        MLP_FBASEUNIT: 'MLP_fBaseUnit',
        MLP_FOPT_BBOTTOMCONSTRUCTION: 'MLP_fOPT_bBottomConstruction',
        MLP_FOPT_BCONDENSEOVERFLOWSWITCH: 'MLP_fOPT_bCondenseOverflowSwitch',
        MLP_FOPT_BDIGITALCOMPRESSOR: 'MLP_fOpt_bDigitalCompressor',
        MLP_FOPT_BDRAINPANTYPES: 'MLP_fOPT_bDrainPanTypes',
        MLP_FOPT_BHAILGUARD: 'MLP_fOPT_bHailGuard',
        MLP_FOPT_BHUMIDIMIZER: 'MLP_fOPT_bHumidimizer',
        MLP_FOPT_BHUMIDITYSENSORS: 'MLP_fOPT_bHumiditySensors',
        MLP_FOPT_BIAQOPTIONS: 'MLP_fOPT_bIAQOptions',
        MLP_FOPT_BLOWAMBIENT: 'MLP_fOPT_bLowAmbient',
        MLP_FOPT_BLOWSOUNDCNDFANS: 'MLP_fOPT_bLowSoundCndFans',
        MLP_FOPT_BMOTORPROTECTION: 'MLP_fOpt_bMotorProtection',
        MLP_FOPT_BNONFUSEDDISCONNECT: 'MLP_fOPT_bNonFusedDisconnect',
        MLP_FOPT_BOUTDOORAIRMEASURE: 'MLP_fOPT_bOutdoorAirMeasure',
        MLP_FOPT_BPHASEMONITOR: 'MLP_fOPT_bPhaseMonitor',
        MLP_FOPT_BREFRIGERANTRELIEFVALUE: 'MLP_fOPT_bRefrigerantReliefValue',
        MLP_FOPT_BRETURNAIRCO2SENSOR: 'MLP_fOPT_bReturnAirCO2Sensor',
        MLP_FOPT_BRETURNAIRSMOKEDETECTOR: 'MLP_fOPT_bReturnAirSmokeDetector',
        MLP_FOPT_BSERVICEPACK: 'MLP_fOPT_bServicePack',
        MLP_FOPT_BSUPPLYFANMOTOR: 'MLP_fOpt_bSupplyFanMotor',
        MLP_FOPT_BTERMINALBLOCK: 'MLP_fOPT_bTerminalBlock',
        MLP_FOPT_BVFDBYPASS: 'MLP_fOpt_bVfdBypass',
        MLP_FOPT_SCOILFINCOATING: 'MLP_fOpt_sCoilFinCoating',
        MLP_FOPT_SCONSTRUCTION: 'MLP_fOPT_sConstruction',
        MLP_FOPT_SCONVENIENCEOUTLET: 'MLP_fOpt_sConvenienceOutlet',
        MLP_FOPT_SHEATOPTION: 'MLP_fOPT_sHeatOption',
        MLP_FOPT_SOUTDOORAIR: 'MLP_fOpt_sOutdoorAir',
        MLP_FOPT_SPREFILTERMSTYPES: 'MLP_fOPT_sPreFilterMSTypes',
        MLP_FOPT_SPREFILTERTYPES: 'MLP_fOPT_sPreFilterTypes',
        MLP_FOPT_SRELIEFTYPE: 'MLP_fOPT_sReliefType',
        MLP_FOPT_SSCCR: 'MLP_fOPT_sSCCR',
        MLP_FOPT_SSUPPLYFANMOTORSIZE: 'MLP_fOpt_sSupplyFanMotorSize',
        MLP_FOPT_SUNITEFFICIENCY: 'MLP_fOpt_sUnitEfficiency',
        MLP_FOPT_BSTAINLESSSTEEL_EXCHANGER: 'MLP_fOPT_bStainlessSteel_Exchanger',
        MLP_FOPT_BBAROMETRICRELIEF: 'MLP_fOPT_bBarometricRelief',
        MLP_FOPT_BEXTENDEDSECTION: 'MLP_fOPT_bExtendedSection',
        MLP_FOPT_BLOWSTATICEXHAUSTFAN: 'MLP_fOPT_bLowStaticExhaustFan',
        MLP_FOPT_BMEDSTATICEXHAUSTFAN: 'MLP_fOPT_bMedStaticExhaustFan',
        MLP_FOPT_BMODULATINGBPCONTROL: 'MLP_fOPT_bModulatingBPControl',
        MLP_FOPT_BOPTIONALCONTROLS: 'MLP_fOPT_bOptionalControls',
        MLP_FOPT_BOUTDOORAIRFLOW: 'MLP_fOPT_bOutdoorAirflow',
        MLP_FOPT_BPLENUMSECTION: 'MLP_fOPT_bPlenumSection',
        MLP_FOPT_BSTDSTATICEXHAUSTFAN: 'MLP_fOPT_bStdStaticExhaustFan',
        MLP_FOPT_SCHASSIS: 'MLP_fOpt_sChassis',
        MLP_FOPT_SMOTORSTATIC: 'MLP_fOPT_sMotorStatic',
        MLP_FOPT_SSOUNDOPTION: 'MLP_fOPT_sSoundOption',
    },
    [TAGS.OPT_CAT_INDOOR]: {
        OPT_BAUTOSELECTSUPPLYFANMOTORSIZE: 'OPT_bAutoSelectSupplyFanMotorSize',
        OPT_BMOTORPROTECTION: 'Opt_bMotorProtection',
        OPT_BSUPPLYFANMOTOR: 'Opt_bSupplyFanMotor',
        OPT_BVFDBYPASS: 'Opt_bVfdBypass',
        OPT_SSUPPLYFANMOTORSIZE: 'Opt_sSupplyFanMotorSize',
        OPT_SSUPPLYFANMOTORSIZE_CHILDREN: 'Opt_sSupplyFanMotorSize.CHILDREN',
        OPT_SMOTORSTATIC: 'OPT_sMotorStatic',
        OPT_SMOTORSTATIC_CHILDREN: 'OPT_sMotorStatic.CHILDREN',
    },
    [TAGS.OPT_CAT_MISC]: {
        OPT_BAUTOSELECTSUPPLYFANMOTORSIZE: 'OPT_bAutoSelectSupplyFanMotorSize',
        OPT_BBOTTOMCONSTRUCTION: 'OPT_bBottomConstruction',
        OPT_BCONDENSEOVERFLOWSWITCH: 'OPT_bCondenseOverflowSwitch',
        OPT_BDIGITALCOMPRESSOR: 'Opt_bDigitalCompressor',
        OPT_BDRAINPANTYPES: 'OPT_bDrainPanTypes',
        OPT_BHAILGUARD: 'OPT_bHailGuard',
        OPT_BHUMIDIMIZER: 'OPT_bHumidimizer',
        OPT_BHUMIDIMIZER_CHILDREN: 'OPT_bHumidimizer.CHILDREN',
        OPT_BHUMIDITYSENSORS: 'OPT_bHumiditySensors',
        OPT_BIAQOPTIONS: 'OPT_bIAQOptions',
        OPT_BLOWAMBIENT: 'OPT_bLowAmbient',
        OPT_BLOWSOUNDCNDFANS: 'OPT_bLowSoundCndFans',
        OPT_BMOTORPROTECTION: 'Opt_bMotorProtection',
        OPT_BNONFUSEDDISCONNECT: 'OPT_bNonFusedDisconnect',
        OPT_BPHASEMONITOR: 'OPT_bPhaseMonitor',
        OPT_BREFRIGERANTRELIEFVALUE: 'OPT_bRefrigerantReliefValue',
        OPT_BRETURNAIRCO2SENSOR: 'OPT_bReturnAirCO2Sensor',
        OPT_BRETURNAIRSMOKEDETECTOR: 'OPT_bReturnAirSmokeDetector',
        OPT_BSERVICEPACK: 'OPT_bServicePack',
        OPT_BSUPPLYFANMOTOR: 'Opt_bSupplyFanMotor',
        OPT_BTERMINALBLOCK: 'OPT_bTerminalBlock',
        OPT_BVFDBYPASS: 'Opt_bVfdBypass',
        OPT_NONFUSEDDISCONNECT_NOTE: 'OPT_Nonfuseddisconnect_Note',
        OPT_SCOILFINCOATING: 'Opt_sCoilFinCoating',
        OPT_SCONSTRUCTION: 'OPT_sConstruction',
        OPT_SCONVENIENCEOUTLET: 'Opt_sConvenienceOutlet',
        OPT_SHEATOPTION: 'OPT_sHeatOption',
        OPT_SOUTDOORAIR: 'Opt_sOutdoorAir',
        OPT_SPREFILTERMSTYPES: 'OPT_sPreFilterMSTypes',
        OPT_SPREFILTERTYPES: 'OPT_sPreFilterTypes',
        OPT_SRELIEFTYPE: 'OPT_sReliefType',
        OPT_SRELIEFTYPE_CHILDREN: 'OPT_sReliefType.CHILDREN',
        OPT_SSCCR: 'OPT_sSCCR',
        OPT_SSCCR_NOTE: 'OPT_sSCCR_Note',
        OPT_SSUPPLYFANMOTORSIZE: 'Opt_sSupplyFanMotorSize',
        OPT_SSUPPLYFANMOTORSIZE_CHILDREN: 'Opt_sSupplyFanMotorSize.CHILDREN',
        OPT_SUNITEFFICIENCY: 'Opt_sUnitEfficiency',
        OPT_BSTAINLESSSTEEL_EXCHANGER: 'OPT_bStainlessSteel_Exchanger',
        OPT_BBAROMETRICRELIEF: 'OPT_bBarometricRelief',
        OPT_BEXTENDEDSECTION: 'OPT_bExtendedSection',
        OPT_BLOWSTATICEXHAUSTFAN: 'OPT_bLowStaticExhaustFan',
        OPT_BLOWSTATICEXHAUSTFAN_CHILDREN: 'OPT_bLowStaticExhaustFan.CHILDREN',
        OPT_BLOWSTATICEXHAUSTFAN_CONTROLTYPE_VALID: 'OPT_bLowStaticExhaustFan.CONTROLTYPE.VALID',
        OPT_BMEDSTATICEXHAUSTFAN: 'OPT_bMedStaticExhaustFan',
        OPT_BMEDSTATICEXHAUSTFAN_CHILDREN: 'OPT_bMedStaticExhaustFan.CHILDREN',
        OPT_BMODULATINGBPCONTROL: 'OPT_bModulatingBPControl',
        OPT_BOUTDOORAIRFLOW: 'OPT_bOutdoorAirflow',
        OPT_BSTDSTATICEXHAUSTFAN: 'OPT_bStdStaticExhaustFan',
        OPT_BSTDSTATICEXHAUSTFAN_CHILDREN: 'OPT_bStdStaticExhaustFan.CHILDREN',
        OPT_SCHASSIS: 'Opt_sChassis',
        OPT_SCOMPRESSOR: 'OPT_sCompressor',
        OPT_SMOTORSTATIC: 'OPT_sMotorStatic',
        OPT_SMOTORSTATIC_CHILDREN: 'OPT_sMotorStatic.CHILDREN',
        OPT_BPLENUMSECTION: 'OPT_bPlenumSection',
    },
    [TAGS.OPT_CAT_CONS]: {
        OPT_BBOTTOMCONSTRUCTION: 'OPT_bBottomConstruction',
        OPT_SCONSTRUCTION: 'OPT_sConstruction',
        OPT_BEXTENDEDSECTION: 'OPT_bExtendedSection',
        OPT_BPLENUMSECTION: 'OPT_bPlenumSection',
    },
    [TAGS.OPT_CAT_SS]: {
        OPT_BCONDENSEOVERFLOWSWITCH: 'OPT_bCondenseOverflowSwitch',
        OPT_BREFRIGERANTRELIEFVALUE: 'OPT_bRefrigerantReliefValue',
        OPT_BRETURNAIRSMOKEDETECTOR: 'OPT_bReturnAirSmokeDetector',
        OPT_BSERVICEPACK: 'OPT_bServicePack',
        OPT_SPREFILTERMSTYPES: 'OPT_sPreFilterMSTypes',
    },
    [TAGS.OPT_CAT_RC]: {
        OPT_BDIGITALCOMPRESSOR: 'Opt_bDigitalCompressor',
        OPT_BHUMIDIMIZER: 'OPT_bHumidimizer',
        OPT_BHUMIDIMIZER_CHILDREN: 'OPT_bHumidimizer.CHILDREN',
        OPT_BLOWAMBIENT: 'OPT_bLowAmbient',
        OPT_BLOWSOUNDCNDFANS: 'OPT_bLowSoundCndFans',
        OPT_SUNITEFFICIENCY: 'Opt_sUnitEfficiency',
        OPT_SCOMPRESSOR: 'OPT_sCompressor',
    },
    [TAGS.OPT_CAT_COILDRAIN]: {
        OPT_BDRAINPANTYPES: 'OPT_bDrainPanTypes',
        OPT_BHAILGUARD: 'OPT_bHailGuard',
        OPT_SCOILFINCOATING: 'Opt_sCoilFinCoating',
    },
    [TAGS.OPT_CAT_CONT]: {
        OPT_BHUMIDITYSENSORS: 'OPT_bHumiditySensors',
        OPT_BRETURNAIRCO2SENSOR: 'OPT_bReturnAirCO2Sensor',
        OPT_BOUTDOORAIRFLOW: 'OPT_bOutdoorAirflow',
    },
    [TAGS.OPT_CAT_IAQ]: {
        OPT_BIAQOPTIONS: 'OPT_bIAQOptions',
        OPT_SPREFILTERTYPES: 'OPT_sPreFilterTypes',
    },
    [TAGS.OPT_CAT_ELEC]: {
        OPT_BNONFUSEDDISCONNECT: 'OPT_bNonFusedDisconnect',
        OPT_BPHASEMONITOR: 'OPT_bPhaseMonitor',
        OPT_BTERMINALBLOCK: 'OPT_bTerminalBlock',
        OPT_NONFUSEDDISCONNECT_NOTE: 'OPT_Nonfuseddisconnect_Note',
        OPT_SCONVENIENCEOUTLET: 'Opt_sConvenienceOutlet',
        OPT_SSCCR: 'OPT_sSCCR',
        OPT_SSCCR_NOTE: 'OPT_sSCCR_Note',
    },
    [TAGS.OPT_CAT_HEAT]: {
        OPT_SHEATOPTION: 'OPT_sHeatOption',
        OPT_BSTAINLESSSTEEL_EXCHANGER: 'OPT_bStainlessSteel_Exchanger',
    },
    [TAGS.OPT_CAT_OUTDOORAIR_IR]: {
        OPT_SOUTDOORAIR: 'Opt_sOutdoorAir',
        OPT_SRELIEFTYPE: 'OPT_sReliefType',
        OPT_SRELIEFTYPE_CHILDREN: 'OPT_sReliefType.CHILDREN',
        OPT_BBAROMETRICRELIEF: 'OPT_bBarometricRelief',
        OPT_BLOWSTATICEXHAUSTFAN: 'OPT_bLowStaticExhaustFan',
        OPT_BLOWSTATICEXHAUSTFAN_CHILDREN: 'OPT_bLowStaticExhaustFan.CHILDREN',
        OPT_BLOWSTATICEXHAUSTFAN_CONTROLTYPE_VALID: 'OPT_bLowStaticExhaustFan.CONTROLTYPE.VALID',
        OPT_BMEDSTATICEXHAUSTFAN: 'OPT_bMedStaticExhaustFan',
        OPT_BMEDSTATICEXHAUSTFAN_CHILDREN: 'OPT_bMedStaticExhaustFan.CHILDREN',
        OPT_BMODULATINGBPCONTROL: 'OPT_bModulatingBPControl',
        OPT_BSTDSTATICEXHAUSTFAN: 'OPT_bStdStaticExhaustFan',
        OPT_BSTDSTATICEXHAUSTFAN_CHILDREN: 'OPT_bStdStaticExhaustFan.CHILDREN',
    },
    [TAGS.UI_CONFIG]: {
        PC_IN_BHASLOWLOADMCHXRESTRICTION: 'PC_In_bHasLowLoadMCHXRestriction',
        PC_IN_BLOCALCORROSIVEENV: 'PC_In_bLocalCorrosiveEnv',
        PC_IN_SCOUNTRYCODE: 'PC_In_sCountryCode',
        PC_IN_SPOSTALCODE: 'PC_In_sPostalCode',
        PC_OUT_BCOILCOATINGREQUIRED: 'PC_Out_bCoilCoatingRequired',
        PC_OUT_BPOSTALCODEVALIDITY: 'PC_Out_bPostalCodeValidity',
        TAG_SCONFIGRULESET: 'Tag_sConfigRuleset',
    },
    [TAGS.UI_CONFIG_UNIT_POSTAL_CODE]: {
        PC_IN_BHASLOWLOADMCHXRESTRICTION: 'PC_In_bHasLowLoadMCHXRestriction',
        PC_IN_BLOCALCORROSIVEENV: 'PC_In_bLocalCorrosiveEnv',
        PC_IN_SCOUNTRYCODE: 'PC_In_sCountryCode',
        PC_IN_SPOSTALCODE: 'PC_In_sPostalCode',
        PC_OUT_BCOILCOATINGREQUIRED: 'PC_Out_bCoilCoatingRequired',
        PC_OUT_BPOSTALCODEVALIDITY: 'PC_Out_bPostalCodeValidity',
    },
    [TAGS.PN]: {
        PN_SMODEL_01: 'PN_sModel.01',
        PN_SMODEL_02: 'PN_sModel.02',
        PN_SMODEL_03: 'PN_sModel.03',
        PN_SMODEL_04: 'PN_sModel.04',
        PN_SMODEL_05: 'PN_sModel.05',
        PN_SMODEL_06: 'PN_sModel.06',
        PN_SMODEL_07: 'PN_sModel.07',
        PN_SMODEL_08: 'PN_sModel.08',
        PN_SMODEL_09: 'PN_sModel.09',
        PN_SMODEL_10: 'PN_sModel.10',
        PN_SMODEL_11: 'PN_sModel.11',
        PN_SMODEL_12: 'PN_sModel.12',
        PN_SMODEL_13: 'PN_sModel.13',
        PN_SMODEL_14: 'PN_sModel.14',
        PN_SMODEL_15: 'PN_sModel.15',
        PN_SMODEL_16: 'PN_sModel.16',
        PN_SMODEL_17: 'PN_sModel.17',
        PN_SMODEL_18: 'PN_sModel.18',
        PN_SREBUILDPARTNUMBER: 'PN_sRebuildPartNumber',
        PN_SREBUILDRULESET: 'PN_sRebuildRuleset',
    },
    [TAGS.STARTUP_CAT_ALL]: {
        STARTUP_BADDITIONALUNITCOOLING: 'StartUp_bAdditionalUnitCooling',
        STARTUP_BADDITIONALUNITHEATING: 'StartUp_bAdditionalUnitHeating',
        STARTUP_BFIRSTUNITCOOLING: 'StartUp_bFirstUnitCooling',
        STARTUP_BFIRSTUNITHEATING: 'StartUp_bFirstUnitHeating',
    },
    [TAGS.UI_CONFIG_UNIT_STARTUP]: {
        STARTUP_BADDITIONALUNITCOOLING: 'StartUp_bAdditionalUnitCooling',
        STARTUP_BADDITIONALUNITHEATING: 'StartUp_bAdditionalUnitHeating',
        STARTUP_BFIRSTUNITCOOLING: 'StartUp_bFirstUnitCooling',
        STARTUP_BFIRSTUNITHEATING: 'StartUp_bFirstUnitHeating',
        STARTUP_SCATEGORY: 'StartUp_sCategory',
    },
    [TAGS.WARRANTY]: {
        STARTUP_BADDITIONALUNITCOOLING: 'StartUp_bAdditionalUnitCooling',
        STARTUP_BADDITIONALUNITHEATING: 'StartUp_bAdditionalUnitHeating',
        STARTUP_BFIRSTUNITCOOLING: 'StartUp_bFirstUnitCooling',
        STARTUP_BFIRSTUNITHEATING: 'StartUp_bFirstUnitHeating',
        STARTUP_SCATEGORY: 'StartUp_sCategory',
        WAR_B1STYEARCARRIERCCSLABOR: 'War_b1stYearCarrierCCSLabor',
        WAR_BCOMPLETE2YEARPARTSANDLABOR: 'War_bComplete2YearPartsAndLabor',
        WAR_BCOMPLETE2YEARPARTSONLY: 'War_bComplete2YearPartsOnly',
        WAR_BCOMPLETE3YEARPARTSANDLABOR: 'War_bComplete3YearPartsAndLabor',
        WAR_BCOMPLETE3YEARPARTSONLY: 'War_bComplete3YearPartsOnly',
        WAR_BCOMPLETE4YEARPARTSANDLABOR: 'War_bComplete4YearPartsAndLabor',
        WAR_BCOMPLETE4YEARPARTSONLY: 'War_bComplete4YearPartsOnly',
        WAR_BCOMPLETE5YEARPARTSANDLABOR: 'War_bComplete5YearPartsAndLabor',
        WAR_BCOMPLETE5YEARPARTSONLY: 'War_bComplete5YearPartsOnly',
        WAR_BCOMPRESSOR2YEARPARTSANDLABOR: 'War_bCompressor2YearPartsAndLabor',
        WAR_BCOMPRESSOR2YEARPARTSONLY: 'War_bCompressor2YearPartsOnly',
        WAR_BCOMPRESSOR3YEARPARTSANDLABOR: 'War_bCompressor3YearPartsAndLabor',
        WAR_BCOMPRESSOR3YEARPARTSONLY: 'War_bCompressor3YearPartsOnly',
        WAR_BCOMPRESSOR4YEARPARTSANDLABOR: 'War_bCompressor4YearPartsAndLabor',
        WAR_BCOMPRESSOR4YEARPARTSONLY: 'War_bCompressor4YearPartsOnly',
        WAR_BCOMPRESSOR5YEARPARTSANDLABOR: 'War_bCompressor5YearPartsAndLabor',
        WAR_BCOMPRESSOR5YEARPARTSONLY: 'War_bCompressor5YearPartsOnly',
        WAR_BALGASHEATEXCHANGERPARTSONLY: 'War_bALGasHeatExchangerPartsOnly',
        WAR_BSSGASHEATEXCHANGERPARTSONLY: 'War_bSSGasHeatExchangerPartsOnly',
    },
    [TAGS.UI_CONFIG_UNIT_WAR]: {
        WAR_B1STYEARCARRIERCCSLABOR: 'War_b1stYearCarrierCCSLabor',
        WAR_BCOMPLETE2YEARPARTSANDLABOR: 'War_bComplete2YearPartsAndLabor',
        WAR_BCOMPLETE2YEARPARTSONLY: 'War_bComplete2YearPartsOnly',
        WAR_BCOMPLETE3YEARPARTSANDLABOR: 'War_bComplete3YearPartsAndLabor',
        WAR_BCOMPLETE3YEARPARTSONLY: 'War_bComplete3YearPartsOnly',
        WAR_BCOMPLETE4YEARPARTSANDLABOR: 'War_bComplete4YearPartsAndLabor',
        WAR_BCOMPLETE4YEARPARTSONLY: 'War_bComplete4YearPartsOnly',
        WAR_BCOMPLETE5YEARPARTSANDLABOR: 'War_bComplete5YearPartsAndLabor',
        WAR_BCOMPLETE5YEARPARTSONLY: 'War_bComplete5YearPartsOnly',
        WAR_BCOMPRESSOR2YEARPARTSANDLABOR: 'War_bCompressor2YearPartsAndLabor',
        WAR_BCOMPRESSOR2YEARPARTSONLY: 'War_bCompressor2YearPartsOnly',
        WAR_BCOMPRESSOR3YEARPARTSANDLABOR: 'War_bCompressor3YearPartsAndLabor',
        WAR_BCOMPRESSOR3YEARPARTSONLY: 'War_bCompressor3YearPartsOnly',
        WAR_BCOMPRESSOR4YEARPARTSANDLABOR: 'War_bCompressor4YearPartsAndLabor',
        WAR_BCOMPRESSOR4YEARPARTSONLY: 'War_bCompressor4YearPartsOnly',
        WAR_BCOMPRESSOR5YEARPARTSANDLABOR: 'War_bCompressor5YearPartsAndLabor',
        WAR_BCOMPRESSOR5YEARPARTSONLY: 'War_bCompressor5YearPartsOnly',
        WAR_BALGASHEATEXCHANGERPARTSONLY: 'War_bALGasHeatExchangerPartsOnly',
        WAR_BSSGASHEATEXCHANGERPARTSONLY: 'War_bSSGasHeatExchangerPartsOnly',
    },
    [TAGS.WAR_CAT_FIRSTYEARLABOR]: {
        WAR_B1STYEARCARRIERCCSLABOR: 'War_b1stYearCarrierCCSLabor',
    },
    [TAGS.WAR_CAT_COMPLETEUNITPARTSANDLABOR]: {
        WAR_BCOMPLETE2YEARPARTSANDLABOR: 'War_bComplete2YearPartsAndLabor',
        WAR_BCOMPLETE3YEARPARTSANDLABOR: 'War_bComplete3YearPartsAndLabor',
        WAR_BCOMPLETE4YEARPARTSANDLABOR: 'War_bComplete4YearPartsAndLabor',
        WAR_BCOMPLETE5YEARPARTSANDLABOR: 'War_bComplete5YearPartsAndLabor',
    },
    [TAGS.WAR_CAT_COMPLETEUNITPARTSONLY]: {
        WAR_BCOMPLETE2YEARPARTSONLY: 'War_bComplete2YearPartsOnly',
        WAR_BCOMPLETE3YEARPARTSONLY: 'War_bComplete3YearPartsOnly',
        WAR_BCOMPLETE4YEARPARTSONLY: 'War_bComplete4YearPartsOnly',
        WAR_BCOMPLETE5YEARPARTSONLY: 'War_bComplete5YearPartsOnly',
    },
    [TAGS.WAR_CAT_CMPUNITPARTSANDLABOR]: {
        WAR_BCOMPRESSOR2YEARPARTSANDLABOR: 'War_bCompressor2YearPartsAndLabor',
        WAR_BCOMPRESSOR3YEARPARTSANDLABOR: 'War_bCompressor3YearPartsAndLabor',
        WAR_BCOMPRESSOR4YEARPARTSANDLABOR: 'War_bCompressor4YearPartsAndLabor',
        WAR_BCOMPRESSOR5YEARPARTSANDLABOR: 'War_bCompressor5YearPartsAndLabor',
    },
    [TAGS.WAR_CAT_CMPUNITPARTSONLY]: {
        WAR_BCOMPRESSOR2YEARPARTSONLY: 'War_bCompressor2YearPartsOnly',
        WAR_BCOMPRESSOR3YEARPARTSONLY: 'War_bCompressor3YearPartsOnly',
        WAR_BCOMPRESSOR4YEARPARTSONLY: 'War_bCompressor4YearPartsOnly',
        WAR_BCOMPRESSOR5YEARPARTSONLY: 'War_bCompressor5YearPartsOnly',
    },
    [TAGS.ACC_CAT_CONVKIT]: {
        ACC_BFLUEKITEXTENSIONKIT: 'Acc_bFlueKitExtensionKit',
        ACC_BLPCONVERSIONKIT: 'Acc_bLPConversionKit',
    },
    [TAGS.WAR_CAT_GASHEATPARTSONLY]: {
        WAR_BALGASHEATEXCHANGERPARTSONLY: 'War_bALGasHeatExchangerPartsOnly',
        WAR_BSSGASHEATEXCHANGERPARTSONLY: 'War_bSSGasHeatExchangerPartsOnly',
    },
    [TAGS.UI_SEL_DC_HW]: {
        DC_FHOTWATERENTERINGFLUIDTEMP: 'DC_fHotWaterEnteringFluidTemp',
        DC_FHOTWATERENTERINGFLUIDTEMP_DISPLAYUNIT: 'DC_fHotWaterEnteringFluidTemp.DISPLAYUNIT',
        DC_FHOTWATERENTERINGFLUIDTEMP_UNIT: 'DC_fHotWaterEnteringFluidTemp.UNIT',
        DC_FHOTWATERFLOWRATE: 'DC_fHotWaterFlowRate',
        DC_FHOTWATERFLOWRATE_DISPLAYUNIT: 'DC_fHotWaterFlowRate.DISPLAYUNIT',
        DC_FHOTWATERFLOWRATE_UNIT: 'DC_fHotWaterFlowRate.UNIT',
        DC_FHOTWATERTEMPDROP: 'DC_fHotWaterTempDrop',
        DC_FHOTWATERTEMPDROP_DISPLAYUNIT: 'DC_fHotWaterTempDrop.DISPLAYUNIT',
        DC_FHOTWATERTEMPDROP_UNIT: 'DC_fHotWaterTempDrop.UNIT',
        DC_SHOTWATERFLOWRATE: 'DC_sHotWaterFlowRate',
        DC_SHOTWATERFLUID: 'DC_sHotwaterFluid',
        DC_SHOTWATERVALVETYPE: 'DC_sHotwaterValveType',
    },
    [TAGS.OPT_CAT_CHASSIS]: {
        OPT_SCHASSIS: 'Opt_sChassis',
    },
};
